const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      platforms: 'Platforms',
      accounts: 'Accounts',
      markets: 'Markets',
      partnership: 'Partnership',
      aboutUs: 'About Us',
      language: 'EN',
      tryDemo: 'Try Demo',
      getStarted: 'Get Started',
      login: 'Login',
      openAccount: 'Open Account'
    },
    
    // Account Types
    accountTypes: {
      proAccount: 'Pro Account',
      primeAccount: 'Prime Account',
      premiumAccount: 'Premium Account'
    },
    
    // Markets
    markets: {
      menuItems: {
        forex: 'Forex',
        indices: 'Indices',
        commodities: 'Commodities',
        shares: 'Shares'
      },
      forex: {
        hero: {
          title: 'Forex',
          subtitle: 'Get connected to the largest financial markets with spreads as low as 0 pips. Use our award winning platform and profit from the currency price fluctuations.',
          question: 'Ready?',
          description: '20 years of experience in Forex Trading',
          experience: '20 years of experience in Forex Trading',
          partners: 'Helped 10,000+ partners with top-notch tools'
        },
        instruments: {
          title: 'River Prime\'s Top Forex Instruments',
          subtitle: 'Go to all instruments',
          headers: {
            symbol: 'Symbol',
            description: 'Description',
            contractSize: 'Contract Size',
            marginRate: 'Margin Rate',
            minSpread: 'Spread Starting From'
          },
          note: '*Note that the margin price fluctuations are influenced by leverage'
        },
        whyTrade: {
          title: 'Why Trade Forex with River Prime?',
          benefits: [
            {
              title: 'Tight Spreads',
              description: 'Tight spreads from 0.0 pips on major currency pairs for maximum profitability'
            },
            {
              title: 'Fast Execution',
              description: 'Lightning-fast order execution with minimal slippage'
            },
            {
              title: 'High Leverage',
              description: 'Leverage up to 1:400 to maximize your trading potential'
            },
            {
              title: 'Advanced Platform',
              description: 'Advanced charting packages and technical analysis tools on MT5'
            },
            {
              title: '24/5 Trading',
              description: '24/5 market access with round-the-clock customer support'
            },
            {
              title: 'Multiple Tools',
              description: 'Access to expert advisors, indicators, and automated trading'
            }
          ]
        },
        accountComparison: {
          title: 'Pick the Best Account to Make Smart Decisions',
          subtitle: 'Choose the account type that suits your trading style',
          accounts: {
            pro: 'Pro',
            prime: 'Prime', 
            premium: 'Premium'
          },
          features: {
            minDeposit: 'Min Deposit',
            spread: 'Spread',
            spreadsFrom: 'Spreads from',
            commission: 'Commission',
            leverage: 'Leverage',
            platform: 'Platform',
            islamicAccounts: 'Islamic Accounts',
            orderExecution: 'Order Execution',
            instruments: 'Instruments',
            support: 'Support',
            findOutMore: 'Find out more',
            available: 'Available',
            market: 'Market',
            startingDeposit: 'Starting Deposit'
          }
        }
      },
      indices: {
        hero: {
          title: 'Indices',
          subtitle: 'Gain exclusive access to the basket of best instruments. Take your position into a large collection of indices. Go long or short on major indices and seize growth opportunities.',
          question: 'Ready?',
          description: 'Trade the world\'s leading stock market indices',
          platform: 'Award-winning trading platform',
          clients: 'Satisfied 10,000+ clients around the world',
          tools: 'Superior tools and instruments'
        },
        instruments: {
          title: 'River Prime\'s Top Indices Instruments',
          subtitle: 'Go to all instruments',
          headers: {
            symbol: 'Symbol',
            description: 'Description',
            contractSize: 'Contract Size',
            marginRate: 'Margin Rate',
            minSpread: 'Min Spread'
          },
          note: '*Note that the margin price fluctuations are influenced by leverage'
        },
        whyTrade: {
          title: 'Why Trade Indices with River Prime?',
          benefits: [
            {
              title: 'Global Diversification',
              description: 'Trade indices from major markets worldwide - US, Europe, and Asia'
            },
            {
              title: 'Tight Spreads',
              description: 'Competitive spreads on all major indices with transparent pricing'
            },
            {
              title: 'Flexible Trading Hours',
              description: 'Access markets at different times based on their local trading sessions'
            },
            {
              title: 'Diversified Exposure',
              description: 'Get exposure to hundreds of companies with a single trade'
            },
            {
              title: 'Advanced Analysis',
              description: 'Comprehensive technical and fundamental analysis tools for all indices'
            },
            {
              title: 'Risk Management',
              description: 'Advanced risk management tools with guaranteed stop orders'
            }
          ]
        },
        accountComparison: {
          title: 'Compare Account Types',
          subtitle: 'Choose the account type that suits your trading style',
          accounts: {
            pro: 'Pro Account',
            prime: 'Prime Account', 
            premium: 'Premium Account'
          },
          features: {
            minDeposit: 'Minimum Deposit',
            spread: 'Spread',
            commission: 'Commission',
            leverage: 'Leverage',
            instruments: 'Instruments',
            support: 'Support',
            startingDeposit: 'Starting Deposit',
            spreadsFrom: 'Spreads from',
            platform: 'Platform',
            islamicAccounts: 'Islamic Accounts',
            orderExecution: 'Order Execution',
            findOutMore: 'Find out more',
            available: 'Available',
            market: 'Market'
          }
        }
      },
      commodities: {
        hero: {
          title: 'Commodities',
          subtitle: 'With a wide selection of the world\'s most popular commodities including energies and metals, enjoy trading with other seasoned investors who take advantage of 24/5 open markets.',
          question: 'Ready?',
          description: 'Trade gold, silver, oil and more',
          mobile: 'On-the-go trading platform',
          global: 'Access to global markets with top-notch tools',
          partners: '10,000+ partners'
        },
        instruments: {
          title: 'River Prime\'s Top Commodities Instruments',
          subtitle: 'Go to all instruments',
          headers: {
            symbol: 'Symbol',
            description: 'Description',
            contractSize: 'Contract Size',
            marginRate: 'Margin Rate',
            minSpread: 'Min Spread'
          },
          note: '*Note that the margin price fluctuations are influenced by leverage'
        },
        whyTrade: {
          title: 'Why Trade Commodities with River Prime?',
          benefits: [
            {
              title: 'Precious Metals',
              description: 'Trade gold and silver as safe haven assets against economic volatility'
            },
            {
              title: 'Energy Markets',
              description: 'Invest in oil and natural gas, the drivers of the global economy'
            },
            {
              title: 'Agricultural Products',
              description: 'Diversify your portfolio with essential agricultural commodities'
            },
            {
              title: 'Market Analysis',
              description: 'Specialized analysis for commodity markets from industry experts'
            },
            {
              title: 'Inflation Protection',
              description: 'Commodities as effective hedge against inflation and currency fluctuations'
            },
            {
              title: 'Fast Execution',
              description: 'Instant trade execution with best available prices'
            }
          ]
        },
        accountComparison: {
          title: 'Compare Account Types',
          subtitle: 'Choose the account type that suits your trading style',
          accounts: {
            pro: 'Pro Account',
            prime: 'Prime Account', 
            premium: 'Premium Account'
          },
          features: {
            minDeposit: 'Minimum Deposit',
            spread: 'Spread',
            commission: 'Commission',
            leverage: 'Leverage',
            instruments: 'Instruments',
            support: 'Support',
            startingDeposit: 'Starting Deposit',
            spreadsFrom: 'Spreads from',
            platform: 'Platform',
            islamicAccounts: 'Islamic Accounts',
            orderExecution: 'Order Execution',
            findOutMore: 'Find out more',
            available: 'Available',
            market: 'Market'
          }
        }
      },
      shares: {
        hero: {
          title: 'Shares CFDs',
          subtitle: 'Trade on over 300 equities and ETFs at competitive rates. Access the world\'s most popular companies like Apple, Amazon, Microsoft and more.',
          question: 'Ready?',
          description: 'Trade shares from leading global companies',
          platform: 'Award-winning trading platform',
          clients: 'Satisfied 10,000+ clients around the world',
          tools: 'Superior tools and instruments'
        },
        instruments: {
          title: 'River Prime\'s Top Shares Instruments',
          subtitle: 'Go to all instruments',
          headers: {
            symbol: 'Symbol',
            description: 'Description',
            contractSize: 'Contract Size',
            marginRate: 'Margin Rate'
          },
          note: '*Note that the margin price fluctuations are influenced by leverage'
        },
        whyTrade: {
          title: 'Why Trade Shares with River Prime?',
          benefits: [
            {
              title: 'Tech Giants',
              description: 'Trade shares of technology giants like Apple, Google, and Microsoft'
            },
            {
              title: 'Financial Sector',
              description: 'Invest in major global banks and financial institutions'
            },
            {
              title: 'Short Selling',
              description: 'Trade both long and short - profit from market movements in both directions'
            },
            {
              title: 'Zero Commissions',
              description: 'Trade share CFDs with no additional commission fees'
            },
            {
              title: 'Leverage',
              description: 'Use leverage up to 1:20 to maximize your buying power'
            },
            {
              title: 'Stock Analysis',
              description: 'Comprehensive company analysis with financial reports and news'
            }
          ]
        },
        accountComparison: {
          title: 'Compare Account Types',
          subtitle: 'Choose the account type that suits your trading style',
          accounts: {
            pro: 'Pro Account',
            prime: 'Prime Account', 
            premium: 'Premium Account'
          },
          features: {
            minDeposit: 'Minimum Deposit',
            spread: 'Spread',
            commission: 'Commission',
            leverage: 'Leverage',
            instruments: 'Instruments',
            support: 'Support',
            startingDeposit: 'Starting Deposit',
            spreadsFrom: 'Spreads from',
            platform: 'Platform',
            islamicAccounts: 'Islamic Accounts',
            orderExecution: 'Order Execution',
            findOutMore: 'Find out more',
            available: 'Available',
            market: 'Market'
          }
        }
      }
    },
    
    // About Us
    about: {
      companyValues: 'Company Values',
      whyRiverPrime: 'Why River Prime',
      regulations: 'Regulations',
      contactUs: 'Contact Us'
    },

    // Company Values Page
    companyValues: {
      hero: {
        title: 'Our Values',
        subtitle: 'The principles that guide everything we do at River Prime'
      },
      values: {
        customerFocus: {
          title: 'Customer Focus',
          description: 'Our customers are at the heart of everything we do. This means understanding their needs, exceeding their expectations, and building long-lasting relationships. Every interaction is an opportunity to demonstrate our commitment to delivering outstanding value and exceptional service.'
        },
        excellenceIntegrity: {
          title: 'Excellence & Integrity',
          description: 'We strive for excellence in all aspects of our work. This encompasses speed, quality, and volume, ensuring that we deliver superior results efficiently. Integrity is the foundation of this pursuit; it involves acting with respect, transparency, loyalty, and always doing the right thing. Together, these principles foster trust and uphold our reputation.'
        },
        riskManagement: {
          title: 'Risk Management',
          description: 'In an ever-changing business environment, effective risk management is crucial. We commit to identifying, assessing, and mitigating risks proactively. This means being prepared for challenges, making informed decisions, and safeguarding our company\'s assets and reputation.'
        },
        collaboration: {
          title: 'Collaboration',
          description: 'Success is a collective effort. We believe in the power of collaboration, both within teams and across the entire organization. By leveraging our diverse talents and working together, we create synergies that drive innovation, solve problems more effectively, and achieve greater results than any of us could alone.'
        },
        continuousImprovement: {
          title: 'Continuous Improvement',
          description: 'Continuous improvement is key to our success. We are dedicated to the learning and development of both hard and soft skills. By investing in our personal and professional growth, we enhance our capabilities, adapt to new opportunities, and ensure our long-term competitiveness.'
        }
      },
      valuesInAction: {
        title: 'Values in Action',
        description: 'These values aren\'t just words on a page – they\'re the foundation of how we operate every day. From our customer service team to our executive leadership, everyone at River Prime embodies these principles in their work.',
        stats: {
          traders: 'Satisfied Traders Worldwide',
          support: 'Customer Support',
          spread: 'Spread from',
          leverage: 'Maximum Leverage'
        }
      },
      cta: {
        title: 'Ready to Experience Our Values?',
        description: 'Join thousands of traders who trust River Prime for their trading journey.',
        button: 'Start Trading Today'
      }
    },
    
    // Partnership Page
    partnership: {
      hero: {
        title: 'Introducing Broker',
        subtitle: 'Take advantage of River Prime\'s personalized multi-tiered rebate and commission schemes. Earn competitive refunds on client referrals with the assistance of our dedicated account managers.',
        ctaButton: 'Check the IB guide & IB Agreement',
        features: {
          clients: 'Trusted by 10,000 clients worldwide',
          platform: 'Award-winning Platform',
          markets: 'Access to 100+ Markets'
        }
      },
      howItWorks: {
        title: 'How Introducing Broker Partnership Works?',
        description1: 'Our one-of-a-kind partner dashboard is committed to displaying a high level of revenue for all introducing partners.',
        description2: 'You\'ll have access to an advanced tracking system, trading activity statistics, trading volume, registrations and real-time conversions.',
        incomeHighlight: 'Earn an ongoing lifetime income with just a few simple clicks'
      },
      whyRiverPrime: {
        title: 'Why River Prime\'s Introducing Broker Program?',
        benefits: {
          tracking: 'Acquire cutting-edge real-time tracking technology.',
          profits: 'Earn your profits as soon as your clients become active traders with a minimum deposit.',
          analytics: 'Get instant access to your clients\' activities to analyze their results.',
          support: 'Take advantage of the assistance of a dedicated team of trading specialists.',
          accounts: 'Start benefiting from a variety of accounts with different schemes.'
        },
        download: {
          title: 'Still not ready?',
          description: 'Download your ultimate Introducing Broker Guide and the IB Agreement for more information.',
          guideButton: 'Download IB Guide',
          agreementButton: 'Download IB Agreement'
        }
      },
      quickHelp: {
        title: 'Quick and Easy Help',
        experienced: {
          title: 'Are You an Experienced Trader?',
          partner: {
            title: 'Be Partner',
            description: 'Expand your potential outcome through our partnership programs.'
          },
          markets: {
            title: 'Explore All Markets',
            description: 'Get access to a world of opportunities & diversify your portfolio with new markets.'
          },
          events: {
            title: 'Know all Economic Events',
            description: 'Dive into a creative economic calendar that provides up-to-date information on economic events.'
          }
        },
        newTrader: {
          title: 'Are you a New Trader?',
          platform: {
            title: 'Online Trading Platform',
            description: 'Use our one-click trading platform. Make money from the leading financial markets while you sleep.'
          },
          charts: {
            title: 'Understand Trading Charts',
            description: 'Chart analysis can help you understand the current state of any market. Concise insights for informed decisions.'
          },
          demo: {
            title: 'Create a Demo Account',
            description: 'Create a trading strategy based on facts. Learn how to create a profitable trading strategy.'
          }
        }
      },
      finalCta: {
        title: 'Ready to Start Your Partnership Journey?',
        description: 'Join thousands of successful partners and start earning today with River Prime\'s Introducing Broker Program.',
        partnerButton: 'Become an IB Partner',
        contactButton: 'Contact Us'
      }
    },
    
    // Hero Section
    hero: {
      title: 'Trade with Confidence',
      subtitle: 'Access global markets with our advanced trading platforms and professional-grade tools.',
      description: 'Join thousands of traders who trust RiverPrime for their trading success.',
      createAccount: 'Create Account',
      tryDemo: 'Try Demo',
      
      // Trading Cards
      forexTrading: 'Forex Trading',
      indicesStocks: 'Indices & Stocks',
      commodities: 'Commodities'
    },
    
    // Sections
    sections: {
      trustworthyBroker: 'A Trustworthy Multi-regulated Broker',
      trustworthyDescription: 'A trusted destination for traders worldwide, regulated in Malaysia and Saint Vincent, with multi-lingual 24/5 support.',
      awardWinning: 'An Award-winning Trading platform',
      awardDescription: 'With tight spreads and 0 commission, you can access the world\'s markets and explore endless trading opportunities.',
      accessToMarkets: 'ACCESS TO MARKETS',
      yearsExperience: 'YEARS OF EXPERIENCE'
    },
    
    // Footer
    footer: {
      contactInfo: 'Contact Info',
      dubaiOffice: 'Dubai - United Arab Emirates',
      ammanOffice: 'Amman - Jordan',
      phoneNumber: 'Phone Number',
      emailAddress: 'Email Address',
      followUs: 'Follow Us',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      support: 'Support',
      allRightsReserved: 'All rights reserved.',
      workingHours: 'Working Hours',
      address: 'Address',
      contact: 'Contact',
      mondayFriday: 'Monday - Friday',
      workingTime: '9:00am - 5:00pm',
      available24_5: 'Available 24/5',
      dubaiAddress: 'Al Doul 4th, Business Bay, Ubora Tower, Dubai 404, 391030 UAE',
      dubaiPhone: '+ 971 4 586 0700',
      ammanAddress: 'Jawharat Al Rabieh Complex, Kabul Street, Amman, Jordan',
      ammanPhone: '+ 962 6 400 0005',
      supportEmail: 'support@riverprime.com',
      companyRegistration: 'River Prime Ltd is incorporated in Saint Vincent and the Grenadines under Number: 23007 IBC 2015 situated in Suite 305, Griffith Corporate Centre, Beachmont, P.O.Box 1510, Kingstown, Saint Vincent and the Grenadines.'
    },
    
    // Trading Steps
    tradingSteps: {
      title: 'Simple steps to start trading',
      step1Title: 'Register account',
      step1Description: 'Create your trading account in minutes with our simple registration process.',
      step2Title: 'Fund your account',
      step2Description: 'Deposit funds securely using various payment methods including bank transfer and e-wallets.',
      step3Title: 'Start your trade',
      step3Description: 'Access our award-winning platform and start trading across multiple asset classes.',
      getStartedButton: 'Get Started Today',
      learnMoreButton: 'Learn More'
    },

    // PDF Modal
    pdfModal: {
      download: 'Download',
      closeModal: 'Close modal'
    },

    // About Section
    about: {
      title: 'Discover a World of Opportunities',
      subtitle: 'Discover how to profit from your asset. Find a new way to trade the future in key markets. Trade currencies, stocks, commodities, indices and much more from a single platform.',
      description: 'River Prime has your back with a personalized financial trading strategy to diversify your portfolio and enjoy trading 24 hours a day.',
      stats: {
        markets: 'Markets',
        peopleJoin: 'People Join',
        expertAdvisor: 'Expert Advisor'
      }
    },

    // Account Types Section
    accountTypes: {
      title: 'Accounts with Unique Features',
      subtitle: 'Because better investment begins with the right place to start, we\'ve created various types of accounts based on your investment strategy.',
      labels: {
        spreadsFrom: 'Spreads From',
        commission: 'Commission',
        leverage: 'Leverage',
        stopOut: 'Stop Out',
        platform: 'Platform',
        minDeposit: 'Min Deposit',
        islamicAccounts: 'Islamic Accounts',
        execution: 'Execution',
        minOrder: 'Min Order',
        currency: 'Currency',
        hedging: 'Hedging',
        ea: 'EA',
        instruments: 'Trading Instruments',
        available: 'Available',
        allowed: 'Allowed',
        yes: 'Yes',
        market: 'Market',
        instrumentsText: 'FX, Metals, Commodities, Indices, Shares CFDs'
      },
      buttons: {
        findOutMore: 'Find out more',
        createAccount: 'Create Account'
      }
    },

    // Services Section
    services: {
      title: 'Get Industry-Leading Prices',
      subtitle: 'Find spreads as low as 0.0 pips for Forex and stock trading using our powerful platforms.',
      forex: {
        title: 'Forex',
        priceLabel: 'Spread as low as',
        priceValue: '0.0 pip',
        description: 'Trade 200+ Forex spot pairs and 200+ futures across majors and minors with a handful of instruments.'
      },
      indices: {
        title: 'Indices',
        priceLabel: 'Commission as low as',
        priceValue: '$0',
        description: 'Trade on the world\'s largest stock marketplaces using the most powerful tools available.'
      },
      shares: {
        title: 'Shares',
        priceLabel: 'Commission as low as',
        priceValue: '$0',
        description: 'Enjoy leveraged commission-free on trading. Get access to 1000+ CFD stocks. Go long or short easily.'
      },
      commodities: {
        title: 'Commodities',
        priceLabel: 'Spread as low as',
        priceValue: '0.004 pip',
        description: 'Get ahead by trading on energy and metals. Drive the global economy.'
      },
      ctaText: 'Start your financial trading journey now',
      ctaButton: 'Create Account'
    },

    // Platforms Page
    platforms: {
      hero: {
        title: 'MetaTrader 5',
        subtitle: 'An all-in-one trading application is here to change your life. Invest in whatever you want, whenever you want! Markets are at your fingertips.',
        question: 'Ready?',
        description: 'An award-winning platform, equipped with 28 innovative tools, opens a door for all partners who want to grow their investment portfolio'
      },
      whyTrade: {
        title: 'Why trade on MetaTrader 5 with River Prime?',
        features: {
          userFriendly: 'Easy go-on application for newbies and seasoned traders.',
          innovativeTools: 'Innovative tools and simple guides to get started.',
          security: 'Top-notch security technologies for a seamless experience.',
          support: '24/5 customer service.',
          flexibility: 'Flexible access to different trading platforms.',
          lowDeposit: 'Trading and investing with the lowest minimum deposit.'
        }
      },
      downloadSteps: {
        title: 'Super easy 3 steps to hit the markets',
        pc: {
          title: 'MT5 for PC',
          step1: 'Download Metatrader 5 for PC',
          step2: 'Run exe. Metatrader 5 file',
          step3: 'Login to your account',
          button: 'Download for PC'
        },
        android: {
          title: 'MT5 for Android',
          step1: 'Go to Google Play Store',
          step2: 'Download Metatrader 5 App',
          step3: 'Login to your account',
          button: 'Download for Android'
        },
        ios: {
          title: 'MT5 for iPhone',
          step1: 'Go to App Store',
          step2: 'Download Metatrader 5 App',
          step3: 'Login to your account',
          button: 'Download for iOS'
        },
        noAccount: 'Don\'t have an account yet?',
        createAccount: 'Create Account'
      },
      tradingInstruments: {
        title: 'What can you trade with MetaTrader 5?',
        forex: 'Forex',
        indices: 'Indices',
        shares: 'Shares',
        commodities: 'Commodities'
      },
      accountTypes: {
        title: 'What\'s next? Choose the Right Account for You',
        pro: {
          name: 'Pro',
          deposit: 'Starting Deposit',
          spreads: 'Spreads from',
          commission: 'Commission',
          leverage: 'Leverage',
          platform: 'Platform',
          islamic: 'Islamic Accounts',
          execution: 'Order Execution',
          button: 'Find out more'
        },
        prime: {
          name: 'Prime',
          popular: 'Most Popular',
          deposit: 'Starting Deposit'
        },
        premium: {
          name: 'Premium',
          deposit: 'Starting Deposit'
        },
        demo: {
          title: 'Not ready yet?',
          description: 'Try the free demo account first',
          button: 'Create Demo Account'
        }
      },
      quickHelp: {
        title: 'Quick and Easy Help',
        experienced: {
          title: 'Are You an Experienced Trader?',
          partner: {
            title: 'Be Partner',
            description: 'Expand your potential outcome through our partnership programs.'
          },
          markets: {
            title: 'Explore All Markets',
            description: 'Get access to a world of opportunities & diversify your portfolio with new markets.'
          },
          events: {
            title: 'Know all Economic Events',
            description: 'Dive into a creative economic calendar that provides up-to-date information on economic events.'
          }
        },
        newTrader: {
          title: 'Are you a New Trader?',
          platform: {
            title: 'Online Trading Platform',
            description: 'Use our one-click trading platform. Make money from the leading financial markets while you sleep.'
          },
          charts: {
            title: 'Understand Trading Charts',
            description: 'Chart analysis can help you understand the current state of any market. Concise insights for informed decisions.'
          },
          demo: {
            title: 'Create a Demo Account',
            description: 'Create a trading strategy based on facts. Learn how to create a profitable trading strategy.'
          }
        }
      }
    },

    // Why River Prime Page
    whyRiverPrime: {
      hero: {
        title: 'Why River Prime?',
        subtitle: 'Simply, because with us, trading makes more sense.'
      },
      story: {
        title: 'River Prime\'s Story',
        intro: 'It all started with a single idea, how to make trading accessible to everyone?',
        paragraph1: 'River Prime began providing brokerage services in the global financial markets 20 years ago and has successfully served over 10,000 loyal clients.',
        paragraph2: 'Ever since, it has led the market with its creativity and best market solutions.',
        quote: 'River Prime\'s philosophy articulates how to be well-prepared to expand your horizons with new opportunities, in order to control and extend your returns. Long years of customer service have paid off, and we\'re thrilled to see the same can-do spirit we fostered in ourselves reflected in our users.'
      },
      numbers: {
        title: 'River Prime in Numbers',
        stats: {
          execution: 'Milliseconds Order execution',
          liquidity: 'Integrated liquidity providers for best quoting',
          orders: 'Order executions per second',
          countries: 'Countries served'
        }
      },
      global: {
        title: 'Global River Prime',
        description1: 'As a reward for our hard-working, River Prime is regulated in Malaysia and Saint Vincent, to help our ever-growing clients to make better investment decisions.',
        description2: 'And because we know how trading looks around, your experience here will be exceptional.',
        features: {
          equalChances: {
            title: 'Equal chances for everyone',
            description: 'Allow all of our clients to access the same data. Without price manipulation, restrictions, or requotes, you can trade with confidence. Our only concern is to assist you in developing strong financial knowledge over time and mastering the game.'
          },
          security: {
            title: 'Your info in a secure, hidden place',
            description: 'Feel safe and secure knowing that your personal information is highly protected by our advanced safeguards. We appreciate you entrusting us with your most valuable possessions, but there is no need to be concerned.'
          },
          openspace: {
            title: 'Openspace for everyone',
            description: 'We build a peaceful community where everyone is welcome, no matter how experienced you are or where you are currently based. Because success in trading equals fair shares of everything to anyone.'
          }
        }
      },
      whoCanTrade: {
        title: 'Who Can Trade With River Prime?',
        subtitle: 'Everybody, in every single corner of the earth.',
        types: {
          newTrader: {
            title: 'New to Trading',
            description: 'If you\'re new to trading, we\'re here to help you make better trading decisions by providing you with insightful analysis tools and the best community to answer all of your questions. We understand that trading is complicated, but well-crafted content will make your journey smoother.'
          },
          knowledgeable: {
            title: 'Knowledgeable but Hesitant',
            description: 'If you know enough about trading but still postpone your decision due to hazy thoughts and a lack of data, we\'re here to help with a comprehensive breakdown. You will learn to maximize your resources and confidently pursue your interests.'
          },
          interested: {
            title: 'Interested but Risk-Averse',
            description: 'If you like the idea of trading but afraid of taking risks, we can help you make informed decisions. That\'s why, creating updated material, tips and guides is critical to River Prime.',
            learnMore: 'Learn and learn some more, then trade.'
          },
          expert: {
            title: 'Expert Trader',
            description: 'If you\'re an expert trader but still experience poor customer service, we\'re here to help. As we team up with some of the world\'s most talented customer service representatives. Our ultimate goal is transparency throughout the process, which you will notice once you sign up.'
          },
          technology: {
            title: 'Technology Concerns',
            description: 'If you\'re concerned about technology\'s complexities, so many tips, and data; we\'re here to assist you with a simple, user-friendly platform. Once you\'ve created your account, you\'ll have access to a step-by-step guide. You will also have access to an expert advisory.'
          }
        }
      },
      advantages: {
        title: 'Advantages of Trading With River Prime',
        items: {
          lowCost: 'Low-cost spreads and low margins',
          platform: 'Lovely platform powered with brilliant tools',
          markets: 'Access to the largest global markets',
          technology: 'Superior technology for valuable insights',
          security: 'Robust security system',
          guides: 'Simple guides crafted by experts',
          community: 'Peaceful community and cheerful support team'
        }
      },
      partners: {
        title: 'River Prime\'s Strategic Partners',
        description: 'We work with leading financial institutions and technology providers to ensure the best trading experience for our clients.'
      },
      cta: {
        title: 'Ready to Experience the River Prime Difference?',
        description: 'Join thousands of traders who have made the smart choice',
        startButton: 'Start Trading Now',
        demoButton: 'Try Demo Account'
      }
    },

    // Regulations Page
    regulations: {
      hero: {
        title: 'River Prime Regulations',
        subtitle: 'Know more about River Prime\'s regulations, agreements, and negative balance protection details.',
        ready: 'Ready?',
        features: {
          clients: '10,000+ clients around the world',
          assets: '1000+ investment assets backed with brilliant tools'
        }
      },
      documents: {
        title: 'River Prime Regulations',
        categories: {
          svg: 'SVG',
          other: 'River Prime Regulations'
        },
        preview: 'Preview',
        cta: {
          title: 'Reliability is our main value. Start your trading experience now.',
          button: 'Start Trading'
        }
      },
      clientAgreement: {
        title: 'River Prime Client Agreement',
        description: 'Comprehensive client agreement for SVG regulated accounts',
        button: 'Preview Agreement',
        statement: 'Proof and certainty are crucial when it comes to money'
      },
      negativeBalance: {
        title: 'River Prime Negative Balance Protection',
        subtitle: 'River Prime accounts provide dependable financial security.',
        explanation: 'Market volatility can sometimes prevent clients from keeping their accounts in the black. River Prime resets its account balance to zero in these cases. It happens automatically when a client\'s account balance falls below zero.',
        feature: 'Protect your account from a negative balance'
      },
      quickHelp: {
        title: 'Quick and Easy Help',
        experienced: {
          title: 'Are You an Experienced Trader?',
          partner: {
            title: 'Be Partner',
            description: 'Expand your potential outcome through our partnership programs.'
          },
          markets: {
            title: 'Explore All Markets',
            description: 'Get access to a world of opportunities & diversify your portfolio with new markets.'
          },
          events: {
            title: 'Know all Economic Events',
            description: 'Dive into a creative economic calendar that provides up-to-date information on economic events.'
          }
        },
        newTrader: {
          title: 'Are you a New Trader?',
          platform: {
            title: 'Online Trading Platform',
            description: 'Use our one-click trading platform. Make money from the leading financial markets while you sleep.'
          },
          charts: {
            title: 'Understand Trading Charts',
            description: 'Chart analysis can help you understand the current state of any market. Concise insights for informed decisions.'
          },
          demo: {
            title: 'Create a Demo Account',
            description: 'Create a trading strategy based on facts. Learn how to create a profitable trading strategy.'
          }
        }
      },
      finalCta: {
        title: 'Trade with Confidence and Security',
        description: 'Our comprehensive regulations and protections ensure your trading experience is safe and compliant.',
        openButton: 'Open Account',
        downloadButton: 'Download All Documents'
      }
    },

    // Support Page
    support: {
      hero: {
        title: 'Ready to start trading? Contact our support team or open an account today.'
      },
      offices: {
        title: 'Our Global Offices',
        saintVincent: {
          name: 'Saint Vincent and the Grenadines',
          address: {
            line1: 'Suite 305, Griffith Corporate Centre',
            line2: 'P.O. Box 1510, Beachmont Kingstown',
            line3: 'St. Vincent and the Grenadines'
          },
          regulation: 'Licensed and regulated by the Financial Services Authority'
        },
        malaysia: {
          name: 'Malaysia',
          address: {
            line1: 'Office 2, Kim Business Center 2, Unit F28, 1st floor',
            line2: 'Paragon Labuan, Jalan Tun Mustapha',
            line3: '87000 F. T. Labuan, Malaysia.'
          }
        }
      },
      contactForm: {
        placeholders: {
          name: 'Your Name',
          email: 'Your Email',
          message: 'Your Message'
        },
        subject: {
          label: 'Select Subject',
          options: {
            general: 'General Inquiry',
            account: 'Account Support',
            trading: 'Trading Support',
            technical: 'Technical Support',
            compliance: 'Compliance',
            partnership: 'Partnership'
          }
        },
        submitButton: 'Send Message',
        successMessage: 'Thank you for your message. We will get back to you soon!'
      }
    },

    // Footer Disclaimer
    disclaimer: {
      title: 'Risk Warning',
      paragraph1: 'Trading derivatives and leveraged products carries a high level of risk, including the risk of losing substantially more than your initial investment. It may not be suitable for everyone. Before you decide to trade, please ensure you understand the risks involved and take into account your investment objectives and level of experience.',
      paragraph2: 'River Prime cannot guarantee and assume no legal responsibility for the relevance, accuracy, topicality or completeness of the information.',
      regionalRestrictions: 'Regional Restrictions:',
      regionalText: 'We do not offer our services to residents of certain jurisdictions such as the United States and to jurisdictions on the FATF and EU/UN sanctions lists.',
      paragraph3: 'The information on this site and the products and services offered are not intended for distribution to any person in any country or jurisdiction where such distribution or use would be contrary to local law or Regulation.'
    },

    // Shared Account Page Content
    accountShared: {
      quickHelp: {
        title: 'Quick and Easy Help',
        experienced: {
          title: 'Are You an Experienced Trader?',
          partner: {
            title: 'Be Partner',
            description: 'Expand your potential outcome through our partnership programs.'
          },
          markets: {
            title: 'Explore All Markets',
            description: 'Get access to a world of opportunities & diversify your portfolio with new markets.'
          },
          events: {
            title: 'Know all Economic Events',
            description: 'Dive into a creative economic calendar that provides up-to-date information on economic events.'
          }
        },
        newTrader: {
          title: 'Are you a New Trader?',
          platform: {
            title: 'Online Trading Platform',
            description: 'Use our one-click trading platform. Make money from the leading financial markets while you sleep.'
          },
          charts: {
            title: 'Understand Trading Charts',
            description: 'Chart analysis can help you understand the current state of any market. Concise insights for informed decisions.'
          },
          demo: {
            title: 'Create a Demo Account',
            description: 'Create a trading strategy based on facts. Learn how to create a profitable trading strategy.'
          }
        }
      },
      specifications: {
        spread: 'Spreads',
        commission: 'Commission',
        leverage: 'Leverage',
        minDeposit: 'Minimum Deposit',
        minOrder: 'Minimum Order Size (lot)',
        stopOut: 'Stop Out Level',
        platform: 'Available Platforms',
        instruments: 'Trading Instruments',
        demoAccount: 'Demo Account',
        economicCalendar: 'Economic Calendar',
        markets: 'Markets',
        expertAdvisory: 'Expert Advisor',
        technicalAnalysis: 'Technical Analysis Tools',
        liveNews: 'Live News',
        maxPositions: 'Max Positions',
        freeData: 'Free Market Data',
        swap: 'Swap',
        phoneSupport: '24/6 Phone Support',
        educationalVideos: 'Educational Videos & Guides',
        chartingPackages: 'Advanced Charting Packages',
        seminars: 'Personal & Online Seminars',
        newsArticles: 'News & Articles from River Prime',
        yes: 'Yes',
        allowed: 'Allowed',
        allMarkets: 'All Markets',
        noLimitations: 'No Limitations',
        free: 'Free*'
      }
    },

    // Account Pages
    proAccount: {
      hero: {
        title: 'Ignite Your Trading With Zero Commission',
        subtitle: 'Get access to a wealth of equity markets, tools, and educational resources.',
        question: 'Ready?',
        features: {
          platform: 'First-Class Trading Platform',
          partners: 'Changed the life of 10,000+ partners',
          tools: 'Exclusive tools and reliable resources'
        }
      },
      benefits: {
        title: 'What You\'ll Get With The Pro Account',
        subtitle: 'Endless Benefits',
        items: {
          spreads: 'Tight spreads, zero commissions, and minimum order size 0.01',
          instruments: 'Trading on 2000+ instruments',
          platform: 'Superior trading platform for PC or mobile',
          deposits: 'Instant deposits and fast withdrawals anytime',
          charting: 'Expert charting packages to expand your portfolio',
          education: 'Free educational resources',
          support: 'Friendly, helpful, multilingual customer support 24/5',
          data: 'Free innovative data, research and analytics tools',
          protection: 'Negative balance protection'
        },
        cta: 'Fund, trade, trade again, get access to our finest features and tools.',
        button: 'Start Now'
      },
      specifications: {
        title: 'Pro Account Specifications',
        spread: 'Variable / Low from pip',
        commission: '$0',
        leverage: '1:400',
        minDeposit: '$20',
        minOrder: '0.01',
        stopOut: '20%',
        platform: 'MT5',
        instruments: 'Currencies, Metals, Commodities, Indices, Stock CFDs',
        demoAccount: 'Yes',
        economicCalendar: 'Yes',
        markets: 'All Markets',
        expertAdvisory: 'Allowed',
        technicalAnalysis: 'Yes',
        liveNews: 'Yes',
        maxPositions: 'No Limitations',
        freeData: 'Yes',
        swap: 'Free*',
        phoneSupport: 'Yes',
        educationalVideos: 'Yes',
        chartingPackages: 'Yes',
        seminars: 'Yes',
        newsArticles: 'Yes',
        note: '* Terms and conditions apply.'
      },
      riskWarning: {
        title: 'Don\'t let anyone set your limits. Trade the world',
        excited: 'Excited?',
        subtitle: 'Know before you go!',
        warnings: {
          risk: 'Financial trading involves risk. If the market moves against you, you will lose money. However, because CFDs are leveraged products, the risks can be greater – with potential losses exceeding deposits.',
          management: 'With a River Prime Pro trading account, you can manage your risk exposure using a range of risk management tools, including stops and automated alerts. You\'ll be on the right track.',
          demo: 'Don\'t worry at all, you\'ll get exclusive access to risk management fundamentals, and you can practice your strategies using a pro demo account. Great option!',
          time: 'Time is gold, so don\'t wait any longer. Create your account now!'
        },
        createButton: 'Create Pro Account',
        tourButton: 'Take Me on a Tour to Learn More'
      }
    },

    primeAccount: {
      hero: {
        title: 'The World at Your Doorstep',
        subtitle: 'Invest wisely. Save much. Prime account is the optimal path to financial independence. Learn how to manage your money well.',
        question: 'Ready?',
        features: {
          journey: 'River Prime\'s journey started 20 years ago',
          partners: 'Join 10,000+ partners',
          tools: 'Diverse financial tools. Smart tools.'
        }
      },
      benefits: {
        title: 'What You\'ll Get With The Prime Account',
        subtitle: 'Endless Benefits',
        items: {
          spreads: 'Zero spreads, very low commissions, and minimum order size 0.01',
          instruments: 'Trading on 2000+ instruments',
          platform: 'Superior trading platform for PC or mobile',
          deposits: 'Instant deposits and fast withdrawals anytime',
          charting: 'Expert charting packages to expand your portfolio',
          education: 'Free educational resources',
          support: 'Friendly, helpful, multilingual customer support 24/5',
          data: 'Free innovative data, research and analytics tools',
          protection: 'Negative balance protection'
        },
        cta: 'No one can stop you. Go ahead. Trade wisely.',
        button: 'Start Now'
      },
      specifications: {
        title: 'Prime Account Specifications',
        spread: 'Variable / Zero spread from',
        commission: '$3 per lot',
        leverage: '1:500',
        minDeposit: '$500',
        minOrder: '0.01',
        stopOut: '20%',
        platform: 'MT5',
        instruments: 'Currencies, Metals, Commodities, Indices, Stock CFDs',
        demoAccount: 'Yes',
        economicCalendar: 'Yes',
        markets: 'All Markets',
        expertAdvisory: 'Allowed',
        technicalAnalysis: 'Yes',
        liveNews: 'Yes',
        maxPositions: 'No Limitations',
        freeData: 'Yes',
        swap: 'Free*',
        phoneSupport: 'Yes',
        educationalVideos: 'Yes',
        chartingPackages: 'Yes',
        seminars: 'Yes',
        newsArticles: 'Yes',
        note: '* Terms and conditions apply.'
      },
      riskWarning: {
        title: 'Don\'t let anyone set your limits. Trade the world',
        excited: 'Excited?',
        subtitle: 'Know before you go!',
        warnings: {
          risk: 'Financial trading involves risk. If the market moves against you, you will lose money. However, because CFDs are leveraged products, the risks can be greater – with potential losses exceeding deposits.',
          management: 'With a River Prime Prime trading account, you can manage your risk exposure using a range of risk management tools, including stops and automated alerts. You\'ll be on the right track.',
          demo: 'We\'ll make it happen, we\'ll help you learn risk management fundamentals, and you can practice your strategies using a prime demo account. Great option!',
          time: 'Time is precious, so don\'t wait any longer. Create your account now!'
        },
        createButton: 'Create Prime Account',
        tourButton: 'Take Me on a Tour to Learn More'
      }
    },

    premiumAccount: {
      hero: {
        title: 'Step Into The Premium World',
        subtitle: 'Welcome to the premium world. Where everything is possible and you can trade with the lowest spreads and access to exclusive tools.',
        question: 'Ready?',
        features: {
          platform: 'Premium trading platform with exclusive features',
          experience: 'Premium experience with dedicated support',
          tools: 'Advanced tools and premium resources'
        }
      },
      benefits: {
        title: 'What You\'ll Get With The Premium Account',
        subtitle: 'Premium Benefits',
        items: {
          spreads: 'Lowest spreads in the market, minimal commissions',
          instruments: 'Access to premium instruments and markets',
          platform: 'Advanced premium trading platform',
          deposits: 'Priority processing for deposits and withdrawals',
          charting: 'Professional charting tools and market analysis',
          education: 'Exclusive premium educational content',
          support: 'Dedicated premium support 24/7',
          data: 'Real-time premium market data and insights',
          protection: 'Enhanced account protection and insurance'
        },
        cta: 'Experience premium trading with exclusive benefits.',
        button: 'Start Premium'
      },
      specifications: {
        title: 'Premium Account Specifications',
        spread: 'From 0.0 pips',
        commission: 'Competitive rates',
        leverage: '1:500',
        minDeposit: '$2000',
        minOrder: '0.01',
        stopOut: '20%',
        platform: 'MT5 Premium',
        instruments: 'All Instruments + Premium Markets',
        demoAccount: 'Yes',
        economicCalendar: 'Premium',
        markets: 'All Markets + Exclusive',
        expertAdvisory: 'Allowed',
        technicalAnalysis: 'Premium Tools',
        liveNews: 'Real-time Premium',
        maxPositions: 'Unlimited',
        freeData: 'Premium Data Package',
        swap: 'Optimized*',
        phoneSupport: '24/7 Premium',
        educationalVideos: 'Exclusive Content',
        chartingPackages: 'Premium Suite',
        seminars: 'VIP Access',
        newsArticles: 'Premium Research',
        note: '* Enhanced terms for premium clients.'
      },
      riskWarning: {
        title: 'Premium Trading Experience',
        excited: 'Ready for Premium?',
        subtitle: 'Understanding premium trading',
        warnings: {
          risk: 'Premium trading involves sophisticated financial instruments. Higher leverage means greater potential returns but also increased risk of substantial losses.',
          management: 'Premium accounts come with advanced risk management tools, including professional-grade stops, alerts, and portfolio management features.',
          demo: 'Practice with our premium demo account that mirrors live market conditions with all premium features enabled.',
          time: 'Join our premium community and start trading with institutional-grade tools and support.'
        },
        createButton: 'Create Premium Account',
        tourButton: 'Explore Premium Features'
      }
    },

    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      close: 'Close',
      open: 'Open',
      menu: 'Menu'
    }
  },
  
  ar: {
    // Navigation
    nav: {
      home: 'الرئيسية',
      platforms: 'المنصات',
      accounts: 'الحسابات',
      markets: 'الأسواق',
      partnership: 'الشراكة',
      aboutUs: 'من نحن',
      language: 'عر',
      tryDemo: 'جرب التداول التجريبي',
      getStarted: 'ابدأ الآن',
      login: 'تسجيل الدخول',
      openAccount: 'افتح حساب'
    },
    
    // Account Types
    accountTypes: {
      proAccount: 'حساب المحترف',
      primeAccount: 'الحساب المميز',
      premiumAccount: 'حساب الخبير'
    },
    
    // Markets
    markets: {
      forex: 'العملات الأجنبية',
      indices: 'المؤشرات',
      commodities: 'السلع',
      shares: 'الأسهم'
    },
    
    // About Us
    about: {
      companyValues: 'قيم الشركة',
      whyRiverPrime: 'لماذا ريفر برايم',
      regulations: 'التنظيم والترخيص',
      contactUs: 'اتصل بنا'
    },

    // Company Values Page
    companyValues: {
      hero: {
        title: 'قيمنا',
        subtitle: 'المبادئ التي توجه كل ما نقوم به في ريفر برايم'
      },
      values: {
        customerFocus: {
          title: 'التركيز على العملاء',
          description: 'عملاؤنا هم في صميم كل ما نقوم به. هذا يعني فهم احتياجاتهم وتجاوز توقعاتهم وبناء علاقات طويلة الأمد. كل تفاعل هو فرصة لإظهار التزامنا بتقديم قيمة مميزة وخدمة استثنائية.'
        },
        excellenceIntegrity: {
          title: 'التميز والنزاهة',
          description: 'نسعى للتميز في جميع جوانب عملنا. وهذا يشمل السرعة والجودة والحجم، مما يضمن تحقيق نتائج متفوقة بكفاءة. النزاهة هي أساس هذا السعي؛ وتتضمن التصرف بالاحترام والشفافية والولاء وفعل الشيء الصحيح دائماً. معاً، هذه المبادئ تعزز الثقة وتحافظ على سمعتنا.'
        },
        riskManagement: {
          title: 'إدارة المخاطر',
          description: 'في بيئة عمل متغيرة باستمرار، إدارة المخاطر الفعالة أمر بالغ الأهمية. نلتزم بتحديد وتقييم وتخفيف المخاطر بشكل استباقي. هذا يعني الاستعداد للتحديات واتخاذ قرارات مدروسة وحماية أصول الشركة وسمعتها.'
        },
        collaboration: {
          title: 'التعاون',
          description: 'النجاح هو جهد جماعي. نؤمن بقوة التعاون، سواء داخل الفرق أو عبر المؤسسة بأكملها. من خلال الاستفادة من مواهبنا المتنوعة والعمل معاً، نخلق تآزراً يدفع الابتكار ويحل المشاكل بفعالية أكبر ويحقق نتائج أعظم مما يمكن لأي منا تحقيقه وحده.'
        },
        continuousImprovement: {
          title: 'التحسين المستمر',
          description: 'التحسين المستمر هو مفتاح نجاحنا. نحن ملتزمون بالتعلم وتطوير المهارات التقنية والناعمة. من خلال الاستثمار في نمونا الشخصي والمهني، نعزز قدراتنا ونتكيف مع الفرص الجديدة ونضمن قدرتنا التنافسية طويلة الأمد.'
        }
      },
      valuesInAction: {
        title: 'القيم في العمل',
        description: 'هذه القيم ليست مجرد كلمات على الورق - إنها أساس كيفية عملنا كل يوم. من فريق خدمة العملاء إلى القيادة التنفيذية، كل فرد في ريفر برايم يجسد هذه المبادئ في عمله.',
        stats: {
          traders: 'متداول راضٍ حول العالم',
          support: 'دعم العملاء',
          spread: 'السبريد من',
          leverage: 'أقصى رافعة مالية'
        }
      },
      cta: {
        title: 'مستعد لتجربة قيمنا؟',
        description: 'انضم إلى آلاف المتداولين الذين يثقون في ريفر برايم في رحلة التداول.',
        button: 'ابدأ التداول اليوم'
      }
    },
    
    // Partnership Page
    partnership: {
      hero: {
        title: 'الوسيط المعرف',
        subtitle: 'استفد من خطط الخصومات والعمولات متعددة المستويات المخصصة من ريفر برايم. احصل على مبالغ مردودة تنافسية على الإحالات مع مساعدة مدراء الحسابات المخصصين لدينا.',
        ctaButton: 'تحقق من دليل الوسيط المعرف واتفاقية الوسيط',
        features: {
          clients: 'موثوق به من قبل 10,000 عميل حول العالم',
          platform: 'منصة حائزة على جوائز',
          markets: 'الوصول إلى أكثر من 100 سوق'
        }
      },
      howItWorks: {
        title: 'كيف تعمل شراكة الوسيط المعرف؟',
        description1: 'لوحة الشراكة الفريدة من نوعها ملتزمة بعرض مستوى عالٍ من الإيرادات لجميع الشركاء المعرفين.',
        description2: 'ستحصل على إمكانية الوصول لنظام تتبع متطور وإحصائيات النشاط التجاري وحجم التداول والتسجيلات والتحويلات في الوقت الفعلي.',
        incomeHighlight: 'اكسب دخلاً مدى الحياة مستمراً بنقرات قليلة بسيطة'
      },
      whyRiverPrime: {
        title: 'لماذا برنامج الوسيط المعرف من ريفر برايم؟',
        benefits: {
          tracking: 'احصل على تقنية التتبع المتطورة في الوقت الفعلي.',
          profits: 'اكسب أرباحك بمجرد أن يصبح عملاؤك متداولين نشطين بحد أدنى للإيداع.',
          analytics: 'احصل على وصول فوري لأنشطة عملائك لتحليل نتائجهم.',
          support: 'استفد من مساعدة فريق مخصص من متخصصي التداول.',
          accounts: 'ابدأ في الاستفادة من مجموعة متنوعة من الحسابات بخطط مختلفة.'
        },
        download: {
          title: 'لست مستعداً بعد؟',
          description: 'حمّل دليل الوسيط المعرف النهائي واتفاقية الوسيط للمزيد من المعلومات.',
          guideButton: 'تحميل دليل الوسيط المعرف',
          agreementButton: 'تحميل اتفاقية الوسيط المعرف'
        }
      },
      quickHelp: {
        title: 'مساعدة سريعة وسهلة',
        experienced: {
          title: 'هل أنت متداول متمرس؟',
          partner: {
            title: 'كن شريكاً',
            description: 'وسّع نتائجك المحتملة من خلال برامج الشراكة الخاصة بنا.'
          },
          markets: {
            title: 'استكشف جميع الأسواق',
            description: 'احصل على عالم من الفرص ونوّع محفظتك مع أسواق جديدة.'
          },
          events: {
            title: 'اعرف جميع الأحداث الاقتصادية',
            description: 'انغمس في تقويم اقتصادي إبداعي يوفر معلومات محدثة عن الأحداث الاقتصادية.'
          }
        },
        newTrader: {
          title: 'هل أنت متداول جديد؟',
          platform: {
            title: 'منصة التداول الإلكترونية',
            description: 'استخدم منصة التداول بنقرة واحدة. اكسب المال من الأسواق المالية الرائدة أثناء نومك.'
          },
          charts: {
            title: 'فهم الرسوم البيانية للتداول',
            description: 'تحليل الرسوم البيانية يمكن أن يساعدك على فهم الحالة الحالية لأي سوق. رؤى موجزة لاتخاذ قرارات مدروسة.'
          },
          demo: {
            title: 'إنشاء حساب تجريبي',
            description: 'أنشئ استراتيجية تداول مبنية على الحقائق. تعلم كيفية إنشاء استراتيجية تداول مربحة.'
          }
        }
      },
      finalCta: {
        title: 'مستعد لبدء رحلة الشراكة؟',
        description: 'انضم إلى آلاف الشركاء الناجحين وابدأ في الكسب اليوم مع برنامج الوسيط المعرف من ريفر برايم.',
        partnerButton: 'كن شريك وسيط معرف',
        contactButton: 'اتصل بنا'
      }
    },
    
    // Hero Section
    hero: {
      title: 'تداول بثقة',
      subtitle: 'الوصول إلى الأسواق العالمية مع منصات التداول المتقدمة والأدوات الاحترافية.',
      description: 'انضم إلى آلاف المتداولين الذين يثقون في ريفر برايم لنجاحهم في التداول.',
      createAccount: 'إنشاء حساب',
      tryDemo: 'جرب التداول التجريبي',
      
      // Trading Cards
      forexTrading: 'تداول العملات الأجنبية',
      indicesStocks: 'المؤشرات والأسهم',
      commodities: 'السلع'
    },
    
    // Sections
    sections: {
      trustworthyBroker: 'وسيط موثوق ومنظم متعدد الاختصاصات',
      trustworthyDescription: 'وجهة موثوقة للمتداولين في جميع أنحاء العالم، منظمة في ماليزيا وسانت فنسنت، مع دعم متعدد اللغات على مدار الساعة طوال أيام الأسبوع.',
      awardWinning: 'منصة تداول حائزة على جوائز',
      awardDescription: 'مع فروقات أسعار ضيقة وبدون عمولة، يمكنك الوصول إلى أسواق العالم واستكشاف فرص تداول لا نهائية.',
      accessToMarkets: 'الوصول إلى الأسواق',
      yearsExperience: 'سنوات من الخبرة'
    },
    
    // Footer
    footer: {
      contactInfo: 'معلومات الاتصال',
      dubaiOffice: 'دبي- الإمارات العربية المتحدة',
      ammanOffice: 'عمان - الأردن',
      phoneNumber: 'رقم الهاتف',
      emailAddress: 'البريد الإلكتروني',
      followUs: 'تابعونا',
      privacyPolicy: 'سياسة الخصوصية',
      termsOfUse: 'شروط الاستخدام',
      support: 'الدعم',
      allRightsReserved: 'جميع الحقوق محفوظة.',
      workingHours: 'ساعات العمل',
      address: 'العنوان',
      contact: 'اتصل بنا',
      mondayFriday: 'الاثنين - الجمعه',
      workingTime: '9:00am - 5:00pm',
      available24_5: 'متاح 24/5',
      dubaiAddress: 'الدول الرابع، حي الأعمال، برج Ubora، دبي 404، 391030 الإمارات',
      dubaiPhone: '+ 971 4 586 0700',
      ammanAddress: 'مجمع جوهرة الرابية ، شارع كابول ، عمان ، الأردن',
      ammanPhone: '+ 962 6 400 0005',
      supportEmail: 'support@riverprime.com',
      companyRegistration: 'شركة ريفر برايم المحدودة مسجلة في سانت فنسنت وجزر جرينادين تحت الرقم: 23007 IBC 2015 وتقع في الجناح 305، مركز جريفيث كوربوريت، بيتشمونت، ص.ب 1510، كينغستاون، سانت فنسنت وجزر جرينادين.'
    },
    
    // Trading Steps
    tradingSteps: {
      title: 'خطوات بسيطة لبدء التداول',
      step1Title: 'تسجيل الحساب',
      step1Description: 'أنشئ حساب التداول الخاص بك في دقائق مع عملية التسجيل البسيطة لدينا.',
      step2Title: 'تمويل حسابك',
      step2Description: 'إيداع الأموال بشكل آمن باستخدام طرق دفع متنوعة بما في ذلك التحويل المصرفي والمحافظ الإلكترونية.',
      step3Title: 'ابدأ تداولك',
      step3Description: 'الوصول إلى منصتنا الحائزة على جوائز وبدء التداول عبر فئات الأصول المتعددة.',
      getStartedButton: 'ابدأ اليوم',
      learnMoreButton: 'اعرف المزيد'
    },

    // PDF Modal
    pdfModal: {
      download: 'تحميل',
      closeModal: 'إغلاق النافذة'
    },

    // About Section
    about: {
      title: 'اكتشف عالماً من الفرص',
      subtitle: 'اكتشف كيفية الربح من أصولك. اعثر على طريقة جديدة لتداول المستقبل في الأسواق الرئيسية. تداول العملات والأسهم والسلع والمؤشرات وأكثر من منصة واحدة.',
      description: 'ريفر برايم يدعمك باستراتيجية تداول مالي مخصصة لتنويع محفظتك والاستمتاع بالتداول 24 ساعة في اليوم.',
      stats: {
        markets: 'الأسواق',
        peopleJoin: 'عضو منضم',
        expertAdvisor: 'مستشار خبير'
      }
    },

    // Account Types Section
    accountTypes: {
      title: 'حسابات مصممة خصيصاً لك',
      subtitle: 'ولأن خطوة النجاح الأولى تبدأ في المكان الصحيح ، فقد أنشأنا أنواعاً مختلفة من الحسابات، تتوافق مع استراتيجيتك الاستثمارية .',
      labels: {
        spreadsFrom: 'الفرق يبدأ من',
        commission: 'العمولة',
        leverage: 'الرافعة المالية/ الهامش',
        stopOut: 'مستوى التوقف',
        platform: 'المنصات المتوفرة',
        minDeposit: 'الحد الأدنى للإيداع',
        islamicAccounts: 'حسابات إسلامية',
        execution: 'تنفيذ الأمر',
        minOrder: 'الحد الأدنى لكل طلب',
        currency: 'عملة الحساب',
        hedging: 'التحوط',
        ea: 'استخدام روبوت',
        instruments: 'ادوات التداول',
        available: 'متوفر',
        allowed: 'مسموح',
        yes: 'نعم',
        market: 'مباشر في السوق',
        instrumentsText: 'فوركس, ومعادن, والسلع، والمؤشرات، والأسهم عبر عقود الفروقات'
      },
      buttons: {
        findOutMore: 'اكتشف المزيد',
        createAccount: 'إنشاء حساب'
      }
    },

    // Services Section
    services: {
      title: 'احصل على أسعار رائدة في الصناعة',
      subtitle: 'اعثر على فروق أسعار منخفضة تصل إلى 0.0 نقطة لتداول الفوركس والأسهم باستخدام منصاتنا القوية.',
      forex: {
        title: 'الفوركس',
        priceLabel: 'فرق السعر من',
        priceValue: '0.0 نقطة',
        description: 'تداول أكثر من 200 زوج فوركس فوري و 200+ عقود آجلة عبر العملات الرئيسية والثانوية مع مجموعة من الأدوات.'
      },
      indices: {
        title: 'المؤشرات',
        priceLabel: 'العمولة من',
        priceValue: '0 دولار',
        description: 'تداول في أكبر أسواق الأسهم في العالم باستخدام أقوى الأدوات المتاحة.'
      },
      shares: {
        title: 'الأسهم',
        priceLabel: 'العمولة من',
        priceValue: '0 دولار',
        description: 'استمتع بالتداول بدون عمولة مع الرافعة المالية. احصل على وصول إلى أكثر من 1000 سهم CFD. اذهب طويل أو قصير بسهولة.'
      },
      commodities: {
        title: 'السلع',
        priceLabel: 'فرق السعر من',
        priceValue: '0.004 نقطة',
        description: 'تقدم عبر تداول الطاقة والمعادن. قد الاقتصاد العالمي.'
      },
      ctaText: 'ابدأ رحلة التداول المالي الخاصة بك الآن',
      ctaButton: 'إنشاء حساب'
    },

    // Platforms Page
    platforms: {
      hero: {
        title: 'ميتاتريدر 5',
        subtitle: 'تطبيق تداول شامل هنا لتغيير حياتك. استثمر في أي شيء تريده، في أي وقت تريده! الأسواق في متناول يديك.',
        question: 'مستعد؟',
        description: 'منصة حائزة على جوائز، مجهزة بـ 28 أداة مبتكرة، تفتح باباً لجميع الشركاء الذين يرغبون في تنمية محفظتهم الاستثمارية'
      },
      whyTrade: {
        title: 'لماذا تتداول على ميتاتريدر 5 مع ريفر برايم؟',
        features: {
          userFriendly: 'تطبيق سهل الاستخدام للمتداولين الجدد وذوي الخبرة.',
          innovativeTools: 'أدوات مبتكرة وأدلة بسيطة للبدء.',
          security: 'تقنيات أمان من الدرجة الأولى لتجربة سلسة.',
          support: 'خدمة عملاء 24/5.',
          flexibility: 'وصول مرن لمنصات تداول مختلفة.',
          lowDeposit: 'التداول والاستثمار بأقل حد أدنى للإيداع.'
        }
      },
      downloadSteps: {
        title: 'ثلاث خطوات سهلة جداً لدخول الأسواق',
        pc: {
          title: 'MT5 للكمبيوتر',
          step1: 'تحميل ميتاتريدر 5 للكمبيوتر',
          step2: 'تشغيل ملف ميتاتريدر 5 التنفيذي',
          step3: 'تسجيل الدخول إلى حسابك',
          button: 'تحميل للكمبيوتر'
        },
        android: {
          title: 'MT5 للأندرويد',
          step1: 'الذهاب إلى متجر جوجل بلاي',
          step2: 'تحميل تطبيق ميتاتريدر 5',
          step3: 'تسجيل الدخول إلى حسابك',
          button: 'تحميل للأندرويد'
        },
        ios: {
          title: 'MT5 للآيفون',
          step1: 'الذهاب إلى متجر التطبيقات',
          step2: 'تحميل تطبيق ميتاتريدر 5',
          step3: 'تسجيل الدخول إلى حسابك',
          button: 'تحميل للآيفون'
        },
        noAccount: 'لا تملك حساباً بعد؟',
        createAccount: 'إنشاء حساب'
      },
      tradingInstruments: {
        title: 'ماذا يمكنك أن تتداول مع ميتاتريدر 5؟',
        forex: 'الفوركس',
        indices: 'المؤشرات',
        shares: 'الأسهم',
        commodities: 'السلع'
      },
      accountTypes: {
        title: 'ما التالي؟ اختر الحساب المناسب لك',
        pro: {
          name: 'حساب المحترف',
          deposit: 'الإيداع الابتدائي',
          spreads: 'الفروق من',
          commission: 'العمولة',
          leverage: 'الرافعة المالية',
          platform: 'المنصة',
          islamic: 'الحسابات الإسلامية',
          execution: 'تنفيذ الأوامر',
          button: 'اعرف المزيد'
        },
        prime: {
          name: 'الحساب المميز',
          popular: 'الأكثر شعبية',
          deposit: 'الإيداع الابتدائي'
        },
        premium: {
          name: 'حساب الخبير',
          deposit: 'الإيداع الابتدائي'
        },
        demo: {
          title: 'لست مستعداً بعد؟',
          description: 'جرب الحساب التجريبي المجاني أولاً',
          button: 'إنشاء حساب تجريبي'
        }
      },
      quickHelp: {
        title: 'مساعدة سريعة وسهلة',
        experienced: {
          title: 'هل أنت متداول ذو خبرة؟',
          partner: {
            title: 'كن شريكاً',
            description: 'وسع نتائجك المحتملة من خلال برامج الشراكة لدينا.'
          },
          markets: {
            title: 'استكشف جميع الأسواق',
            description: 'احصل على الوصول إلى عالم من الفرص ونوع محفظتك مع أسواق جديدة.'
          },
          events: {
            title: 'اعرف جميع الأحداث الاقتصادية',
            description: 'انغمس في تقويم اقتصادي إبداعي يوفر معلومات محدثة عن الأحداث الاقتصادية.'
          }
        },
        newTrader: {
          title: 'هل أنت متداول جديد؟',
          platform: {
            title: 'منصة التداول الإلكترونية',
            description: 'استخدم منصة التداول بنقرة واحدة. اكسب المال من الأسواق المالية الرائدة أثناء نومك.'
          },
          charts: {
            title: 'فهم الرسوم البيانية للتداول',
            description: 'تحليل الرسوم البيانية يمكن أن يساعدك على فهم الحالة الحالية لأي سوق. رؤى موجزة لاتخاذ قرارات مدروسة.'
          },
          demo: {
            title: 'إنشاء حساب تجريبي',
            description: 'أنشئ استراتيجية تداول مبنية على الحقائق. تعلم كيفية إنشاء استراتيجية تداول مربحة.'
          }
        }
      }
    },

    // صفحة لماذا ريفر برايم
    whyRiverPrime: {
      hero: {
        title: 'لماذا ريفر برايم؟',
        subtitle: 'ببساطة، لأن التداول معنا أكثر منطقية.'
      },
      story: {
        title: 'قصة ريفر برايم',
        intro: 'كل شيء بدأ بفكرة واحدة، كيف نجعل التداول في متناول الجميع؟',
        paragraph1: 'بدأت ريفر برايم في تقديم خدمات الوساطة في الأسواق المالية العالمية قبل 20 عاماً وخدمت بنجاح أكثر من 10,000 عميل مخلص.',
        paragraph2: 'منذ ذلك الحين، قادت السوق بإبداعها وأفضل حلول السوق.',
        quote: 'فلسفة ريفر برايم تشرح كيف تكون مستعداً جيداً لتوسيع آفاقك مع الفرص الجديدة، من أجل السيطرة وتمديد عوائدك. سنوات طويلة من خدمة العملاء أتت ثمارها، ونحن متحمسون لرؤية نفس روح العمل التي عززناها في أنفسنا منعكسة في مستخدمينا.'
      },
      numbers: {
        title: 'ريفر برايم بالأرقام',
        stats: {
          execution: 'تنفيذ الأوامر بالميلي ثانية',
          liquidity: 'مزودي السيولة المتكاملين لأفضل تسعير',
          orders: 'تنفيذ الأوامر في الثانية',
          countries: 'دولة نخدمها'
        }
      },
      global: {
        title: 'ريفر برايم العالمية',
        description1: 'كمكافأة لعملنا الجاد، ريفر برايم منظمة في ماليزيا وسانت فنسنت، لمساعدة عملائنا المتزايدين على اتخاذ قرارات استثمارية أفضل.',
        description2: 'ولأننا نعرف كيف يبدو التداول حولنا، ستكون تجربتك هنا استثنائية.',
        features: {
          equalChances: {
            title: 'فرص متساوية للجميع',
            description: 'نسمح لجميع عملائنا بالوصول إلى نفس البيانات. بدون تلاعب في الأسعار أو قيود أو إعادة تسعير، يمكنك التداول بثقة. همنا الوحيد هو مساعدتك في تطوير معرفة مالية قوية بمرور الوقت وإتقان اللعبة.'
          },
          security: {
            title: 'معلوماتك في مكان آمن ومخفي',
            description: 'اشعر بالأمان والطمأنينة مع العلم أن معلوماتك الشخصية محمية بدرجة عالية بواسطة حمايتنا المتقدمة. نحن نقدر ثقتك بنا بأغلى ممتلكاتك، ولكن لا داعي للقلق.'
          },
          openspace: {
            title: 'مساحة مفتوحة للجميع',
            description: 'نبني مجتمعاً سلمياً حيث يرحب بالجميع، بغض النظر عن مستوى خبرتك أو مكان تواجدك حالياً. لأن النجاح في التداول يعني الأسهم العادلة لكل شيء لأي شخص.'
          }
        }
      },
      whoCanTrade: {
        title: 'من يمكنه التداول مع ريفر برايم؟',
        subtitle: 'الجميع، في كل زاوية من زوايا الأرض.',
        types: {
          newTrader: {
            title: 'جديد في التداول',
            description: 'إذا كنت جديداً في التداول، نحن هنا لمساعدتك على اتخاذ قرارات تداول أفضل من خلال تزويدك بأدوات تحليل ثاقبة وأفضل مجتمع للإجابة على جميع أسئلتك. نحن نفهم أن التداول معقد، ولكن المحتوى المصمم بعناية سيجعل رحلتك أكثر سلاسة.'
          },
          knowledgeable: {
            title: 'واسع المعرفة لكن متردد',
            description: 'إذا كنت تعرف ما يكفي عن التداول ولكنك ما زلت تؤجل قرارك بسبب الأفكار الضبابية ونقص البيانات، نحن هنا للمساعدة بتحليل شامل. ستتعلم كيفية تعظيم مواردك ومتابعة اهتماماتك بثقة.'
          },
          interested: {
            title: 'مهتم لكن يتجنب المخاطر',
            description: 'إذا كنت تحب فكرة التداول لكنك تخاف من المخاطر، يمكننا مساعدتك في اتخاذ قرارات مدروسة. لهذا السبب، إنشاء مواد محدثة ونصائح وأدلة أمر بالغ الأهمية لريفر برايم.',
            learnMore: 'تعلم وتعلم أكثر، ثم تداول.'
          },
          expert: {
            title: 'متداول خبير',
            description: 'إذا كنت متداولاً خبيراً ولكنك ما زلت تواجه خدمة عملاء ضعيفة، نحن هنا للمساعدة. حيث نتعاون مع بعض أكثر ممثلي خدمة العملاء موهبة في العالم. هدفنا النهائي هو الشفافية طوال العملية، والتي ستلاحظها بمجرد التسجيل.'
          },
          technology: {
            title: 'مخاوف التكنولوجيا',
            description: 'إذا كنت قلقاً بشأن تعقيدات التكنولوجيا والكثير من النصائح والبيانات؛ نحن هنا لمساعدتك بمنصة بسيطة وسهلة الاستخدام. بمجرد إنشاء حسابك، ستحصل على دليل خطوة بخطوة. ستحصل أيضاً على استشارة خبير.'
          }
        }
      },
      advantages: {
        title: 'مزايا التداول مع ريفر برايم',
        items: {
          lowCost: 'فروقات منخفضة التكلفة وهوامش منخفضة',
          platform: 'منصة رائعة مدعومة بأدوات رائعة',
          markets: 'الوصول إلى أكبر الأسواق العالمية',
          technology: 'تكنولوجيا متفوقة للحصول على رؤى قيمة',
          security: 'نظام أمان قوي',
          guides: 'أدلة بسيطة مصممة من قبل خبراء',
          community: 'مجتمع سلمي وفريق دعم مبهج'
        }
      },
      partners: {
        title: 'الشركاء الاستراتيجيون لريفر برايم',
        description: 'نعمل مع المؤسسات المالية الرائدة ومزودي التكنولوجيا لضمان أفضل تجربة تداول لعملائنا.'
      },
      cta: {
        title: 'مستعد لتجربة اختلاف ريفر برايم؟',
        description: 'انضم إلى آلاف المتداولين الذين اتخذوا الخيار الذكي',
        startButton: 'ابدأ التداول الآن',
        demoButton: 'جرب الحساب التجريبي'
      }
    },

    // صفحة الأنظمة
    regulations: {
      hero: {
        title: 'أنظمة ريفر برايم',
        subtitle: 'تعرف أكثر على أنظمة ريفر برايم والاتفاقيات وتفاصيل حماية الرصيد السلبي.',
        ready: 'جاهز؟',
        features: {
          clients: '10,000+ عميل حول العالم',
          assets: '1000+ أصل استثماري مدعوم بأدوات رائعة'
        }
      },
      documents: {
        title: 'أنظمة ريفر برايم',
        categories: {
          svg: 'SVG',
          other: 'وثائق أخرى'
        },
        preview: 'معاينة',
        cta: {
          title: 'الموثوقية هي قيمتنا الأساسية. ابدأ تجربة التداول الآن.',
          button: 'ابدأ التداول'
        }
      },
      clientAgreement: {
        title: 'اتفاقية عميل ريفر برايم',
        description: 'اتفاقية عميل شاملة للحسابات المنظمة تحت SVG',
        button: 'معاينة الاتفاقية',
        statement: 'الإثبات واليقين أمران بالغا الأهمية عندما يتعلق الأمر بالمال'
      },
      negativeBalance: {
        title: 'حماية الرصيد السلبي من ريفر برايم',
        subtitle: 'توفر حسابات ريفر برايم أماناً مالياً موثوقاً.',
        explanation: 'قد تمنع تقلبات السوق أحياناً العملاء من الحفاظ على حساباتهم في المنطقة الإيجابية. تقوم ريفر برايم بإعادة تعيين رصيد الحساب إلى الصفر في هذه الحالات. يحدث ذلك تلقائياً عندما ينخفض رصيد حساب العميل إلى ما دون الصفر.',
        feature: 'احمِ حسابك من الرصيد السلبي'
      },
      quickHelp: {
        title: 'مساعدة سريعة وسهلة',
        experienced: {
          title: 'هل أنت متداول ذو خبرة؟',
          partner: {
            title: 'كن شريكاً',
            description: 'وسع نتائجك المحتملة من خلال برامج الشراكة لدينا.'
          },
          markets: {
            title: 'استكشف جميع الأسواق',
            description: 'احصل على الوصول إلى عالم من الفرص ونوع محفظتك مع أسواق جديدة.'
          },
          events: {
            title: 'اعرف جميع الأحداث الاقتصادية',
            description: 'انغمس في تقويم اقتصادي إبداعي يوفر معلومات محدثة عن الأحداث الاقتصادية.'
          }
        },
        newTrader: {
          title: 'هل أنت متداول جديد؟',
          platform: {
            title: 'منصة التداول الإلكترونية',
            description: 'استخدم منصة التداول بنقرة واحدة. اكسب المال من الأسواق المالية الرائدة أثناء نومك.'
          },
          charts: {
            title: 'فهم الرسوم البيانية للتداول',
            description: 'تحليل الرسوم البيانية يمكن أن يساعدك على فهم الحالة الحالية لأي سوق. رؤى موجزة لاتخاذ قرارات مدروسة.'
          },
          demo: {
            title: 'إنشاء حساب تجريبي',
            description: 'أنشئ استراتيجية تداول مبنية على الحقائق. تعلم كيفية إنشاء استراتيجية تداول مربحة.'
          }
        }
      },
      finalCta: {
        title: 'تداول بثقة وأمان',
        description: 'أنظمتنا الشاملة وحمايتنا تضمن أن تجربة التداول آمنة ومتوافقة.',
        openButton: 'افتح حساب',
        downloadButton: 'تحميل جميع المستندات'
      }
    },

    // صفحة الدعم
    support: {
      hero: {
        title: 'مستعد لبدء التداول؟ تواصل مع فريق الدعم أو افتح حساباً اليوم.'
      },
      offices: {
        title: 'مكاتبنا العالمية',
        saintVincent: {
          name: 'سانت فنسنت وجزر غرينادين',
          address: {
            line1: 'جناح 305، مركز جريفيث للشركات',
            line2: 'صندوق بريد 1510، بيتشمونت كينغستاون',
            line3: 'سانت فنسنت وجزر غرينادين'
          },
          regulation: 'مرخصة ومنظمة من قبل هيئة الخدمات المالية'
        },
        malaysia: {
          name: 'ماليزيا',
          address: {
            line1: 'الطوابق 10-12، برج مينارا IGB',
            line2: 'مدينة ميد فالي، لينغكاران سيد بوترا',
            line3: '59200 كوالالمبور'
          }
        }
      },
      contactForm: {
        placeholders: {
          name: 'اسمك',
          email: 'بريدك الإلكتروني',
          message: 'رسالتك'
        },
        subject: {
          label: 'اختر الموضوع',
          options: {
            general: 'استفسار عام',
            account: 'دعم الحساب',
            trading: 'دعم التداول',
            technical: 'الدعم التقني',
            compliance: 'الامتثال',
            partnership: 'الشراكة'
          }
        },
        submitButton: 'إرسال الرسالة',
        successMessage: 'شكراً لك على رسالتك. سنعود إليك قريباً!'
      }
    },

    // Account Pages
    proAccount: {
      hero: {
        title: 'أشعل تداولاتك بدون عمولة',
        subtitle: 'احصل على الوصول إلى ثروة من أسواق الأوراق المالية والأدوات والموارد التعليمية.',
        question: 'جاهز؟',
        features: {
          platform: 'منصة تداول من الطراز الأول',
          partners: 'غيرت حياة أكثر من 10,000 شريك',
          tools: 'أدوات حصرية وموارد موثوقة'
        }
      },
      benefits: {
        title: 'ما ستحصل عليه مع حساب المحترف',
        subtitle: 'فوائد لا نهاية لها',
        items: {
          spreads: 'فروقات ضيقة، عمولات صفر، وحجم طلب أدنى 0.01',
          instruments: 'التداول على أكثر من 2000 أداة',
          platform: 'منصة تداول متفوقة للكمبيوتر الشخصي أو الجوال',
          deposits: 'ودائع فورية وسحوبات سريعة في أي وقت',
          charting: 'حزم رسوم بيانية خبيرة لتوسيع محفظتك',
          education: 'موارد تعليمية مجانية',
          support: 'دعم عملاء ودود ومفيد ومتعدد اللغات 24/5',
          data: 'بيانات وأبحاث وأدوات تحليل مبتكرة مجانية',
          protection: 'حماية الرصيد السلبي'
        },
        cta: 'مول، تداول، تداول مرة أخرى، احصل على الوصول إلى أفضل ميزاتنا وأدواتنا.',
        button: 'ابدأ الآن'
      },
      specifications: {
        title: 'مواصفات حساب المحترف',
        spread: 'متغير / منخفض يصل إلى نقطة واحدة',
        commission: '0 دولار',
        leverage: '1:400',
        minDeposit: '20 دولار',
        minOrder: '0.01',
        stopOut: '20%',
        platform: 'MT5',
        instruments: 'العملات، المعادن، السلع، المؤشرات، عقود فروقات الأسهم',
        demoAccount: 'نعم',
        economicCalendar: 'نعم',
        markets: 'جميع الأسواق',
        expertAdvisory: 'مسموح',
        technicalAnalysis: 'نعم',
        liveNews: 'نعم',
        maxPositions: 'بلا حدود',
        freeData: 'نعم',
        swap: 'مجاناً*',
        phoneSupport: 'نعم',
        educationalVideos: 'نعم',
        chartingPackages: 'نعم',
        seminars: 'نعم',
        newsArticles: 'نعم',
        note: '* تطبق الشروط والأحكام.'
      },
      riskWarning: {
        title: 'لا تدع أحداً يحدد حدودك. تداول العالم',
        excited: 'متحمس؟',
        subtitle: 'اعرف قبل أن تذهب!',
        warnings: {
          risk: 'ينطوي التداول المالي على مخاطر. إذا تحرك السوق ضدك، ستخسر المال. ومع ذلك، نظراً لأن عقود الفروقات هي منتجات بالرافعة المالية، يمكن أن تكون المخاطر أكبر - مع إمكانية خسائر تتجاوز الودائع.',
          management: 'مع حساب التداول المحترف من ريفر برايم، يمكنك إدارة تعرضك للمخاطر باستخدام مجموعة من أدوات إدارة المخاطر، بما في ذلك الإيقافات والتنبيهات المؤتمتة. ستكون على المسار الصحيح.',
          demo: 'لا تقلق على الإطلاق، ستحصل على وصول حصري لأساسيات إدارة المخاطر، ويمكنك ممارسة استراتيجياتك باستخدام حساب تجريبي محترف. خيار رائع!',
          time: 'الوقت من ذهب، لذا لا تنتظر أكثر. أنشئ حسابك الآن!'
        },
        createButton: 'إنشاء حساب المحترف',
        tourButton: 'اصطحبني في جولة لتعلم المزيد'
      }
    },

    primeAccount: {
      hero: {
        title: 'العالم باب جارك',
        subtitle: 'استثمر بحكمة. وفر كثيراً. الحساب المميز هو المسار المثالي للاستقلال المالي. تعلم كيفية إدارة أموالك بشكل جيد.',
        question: 'جاهز؟',
        features: {
          journey: 'بدأت رحلة ريفر برايم قبل 20 عاماً',
          partners: 'انضم إلى أكثر من 10,000 شريك',
          tools: 'أدوات مالية متنوعة. أدوات ذكية.'
        }
      },
      benefits: {
        title: 'ما ستحصل عليه مع الحساب المميز',
        subtitle: 'فوائد لا نهاية لها',
        items: {
          spreads: 'فروقات صفر، عمولات منخفضة جداً، وحجم طلب أدنى 0.01',
          instruments: 'التداول على أكثر من 2000 أداة',
          platform: 'منصة تداول متفوقة للكمبيوتر الشخصي أو الجوال',
          deposits: 'ودائع فورية وسحوبات سريعة في أي وقت',
          charting: 'حزم رسوم بيانية خبيرة لتوسيع محفظتك',
          education: 'موارد تعليمية مجانية',
          support: 'دعم عملاء ودود ومفيد ومتعدد اللغات 24/5',
          data: 'بيانات وأبحاث وأدوات تحليل مبتكرة مجانية',
          protection: 'حماية الرصيد السلبي'
        },
        cta: 'لا أحد يستطيع إيقافك. انطلق. تداول بحكمة.',
        button: 'ابدأ الآن'
      },
      specifications: {
        title: 'مواصفات الحساب المميز',
        spread: 'متغير / منخفض يصل إلى 0 نقطة',
        commission: '6 دولارات',
        leverage: '1:400',
        minDeposit: '250 دولار',
        minOrder: '0.01',
        stopOut: '20%',
        platform: 'MT5',
        instruments: 'العملات، المعادن، السلع، المؤشرات، عقود فروقات الأسهم'
      },
      financialMove: {
        title: 'الخطوة المالية البسيطة الواحدة التي ستغير حياتك'
      },
      riskWarning: {
        excited: 'متحمس؟',
        subtitle: 'اعرف قبل أن تذهب!',
        warnings: {
          risk: 'ينطوي التداول المالي على مخاطر. إذا تحرك السوق ضدك، ستخسر المال. ومع ذلك، نظراً لأن عقود الفروقات هي منتجات بالرافعة المالية، يمكن أن تكون المخاطر أكبر - مع إمكانية خسائر تتجاوز الودائع.',
          management: 'مع حساب التداول المميز من ريفر برايم، يمكنك إدارة تعرضك للمخاطر باستخدام مجموعة من أدوات إدارة المخاطر، بما في ذلك الإيقافات والتنبيهات المؤتمتة. ستكون على المسار الصحيح.',
          demo: 'سنساعدك أيضاً في تعلم أساسيات إدارة المخاطر، ويمكنك ممارسة استراتيجياتك باستخدام حساب تجريبي مميز. خيار رائع!',
          gift: 'توقف عن إضاعة الوقت في البحث. لدينا هدية لك!'
        },
        createButton: 'إنشاء الحساب المميز',
        tourButton: 'اصطحبني في جولة لتعلم المزيد.'
      }
    },

    premiumAccount: {
      hero: {
        title: 'اهزم السوق العالمي',
        subtitle: 'اجعل العالم محارتك مع حساب الخبير. أتقن لعبة التداول، واستفد إلى أقصى حد من الأسهم حول العالم.',
        question: 'جاهز؟',
        features: {
          platform: 'منصة حائزة على جوائز سهلة الاستخدام',
          access: 'وصول حصري لأدوات بصيرة',
          partners: 'انضم مع أكثر من 10,000 شريك عالمياً'
        }
      },
      benefits: {
        title: 'ما ستحصل عليه مع حساب الخبير',
        subtitle: 'فوائد لا نهاية لها',
        items: {
          spreads: 'فروقات ضيقة، أقل العمولات، وحجم طلب أدنى 0.01',
          instruments: 'التداول على أكثر من 2000 أداة',
          platform: 'منصة تداول متفوقة للكمبيوتر الشخصي أو الجوال',
          deposits: 'ودائع فورية وسحوبات سريعة في أي وقت',
          charting: 'حزم رسوم بيانية خبيرة لتوسيع محفظتك',
          education: 'موارد تعليمية مجانية',
          support: 'دعم عملاء ودود ومفيد ومتعدد اللغات 24/5',
          data: 'بيانات وأبحاث وأدوات تحليل مبتكرة مجانية',
          protection: 'حماية الرصيد السلبي'
        },
        cta: 'اكسر طريق جني المال. ولت أيام الشعور بأنك محروم.',
        button: 'ابدأ الآن'
      },
      specifications: {
        title: 'مواصفات حساب الخبير',
        spread: 'متغير / منخفض يصل إلى 0 نقطة',
        commission: '3 دولارات',
        leverage: '1:400',
        minDeposit: '3000 دولار',
        minOrder: '0.01',
        stopOut: '20%',
        platform: 'MT5',
        instruments: 'العملات، المعادن، السلع، المؤشرات، عقود فروقات الأسهم'
      },
      riskWarning: {
        excited: 'متحمس؟',
        subtitle: 'اعرف قبل أن تذهب!',
        warnings: {
          risk: 'ينطوي التداول المالي على مخاطر. إذا تحرك السوق ضدك، ستخسر المال. ومع ذلك، نظراً لأن عقود الفروقات هي منتجات بالرافعة المالية، يمكن أن تكون المخاطر أكبر - مع إمكانية خسائر تتجاوز الودائع.',
          management: 'مع حساب التداول المتميز من ريفر برايم، يمكنك إدارة تعرضك للمخاطر باستخدام مجموعة من أدوات إدارة المخاطر، بما في ذلك الإيقافات والتنبيهات المؤتمتة. ستكون على المسار الصحيح.',
          demo: 'سنحقق ذلك، سنساعدك في تعلم أساسيات إدارة المخاطر، ويمكنك ممارسة استراتيجياتك باستخدام حساب تجريبي متميز. خيار رائع!',
          time: 'الوقت ثمين، لذا لا تنتظر أكثر. أنشئ حسابك الآن!'
        },
        createButton: 'إنشاء حساب الخبير',
        tourButton: 'اصطحبني في جولة لتعلم المزيد'
      }
    },

    // Shared Account Page Content
    accountShared: {
      quickHelp: {
        title: 'مساعدة سريعة وسهلة',
        experienced: {
          title: 'هل أنت متداول متمرس؟',
          partner: {
            title: 'كن شريكاً',
            description: 'وسع نتائجك المحتملة من خلال برامج الشراكة الخاصة بنا.'
          },
          markets: {
            title: 'استكشف جميع الأسواق',
            description: 'احصل على الوصول إلى عالم من الفرص ونوع محفظتك مع أسواق جديدة.'
          },
          events: {
            title: 'اعرف جميع الأحداث الاقتصادية',
            description: 'انغمس في تقويم اقتصادي إبداعي يوفر معلومات محدثة عن الأحداث الاقتصادية.'
          }
        },
        newTrader: {
          title: 'هل أنت متداول جديد؟',
          platform: {
            title: 'منصة التداول الإلكترونية',
            description: 'استخدم منصة التداول بنقرة واحدة. اكسب المال من الأسواق المالية الرائدة أثناء نومك.'
          },
          charts: {
            title: 'فهم الرسوم البيانية للتداول',
            description: 'تحليل الرسوم البيانية يمكن أن يساعدك على فهم الحالة الحالية لأي سوق. رؤى موجزة لاتخاذ قرارات مدروسة.'
          },
          demo: {
            title: 'إنشاء حساب تجريبي',
            description: 'أنشئ استراتيجية تداول مبنية على الحقائق. تعلم كيفية إنشاء استراتيجية تداول مربحة.'
          }
        }
      },
      specifications: {
        spread: 'الفروقات',
        commission: 'العمولة',
        leverage: 'الرافعة المالية',
        minDeposit: 'الحد الأدنى للإيداع',
        minOrder: 'الحد الأدنى لحجم الطلب (لوت)',
        stopOut: 'مستوى الإيقاف',
        platform: 'المنصات المتاحة',
        instruments: 'أدوات التداول',
        demoAccount: 'الحساب التجريبي',
        economicCalendar: 'التقويم الاقتصادي',
        markets: 'الأسواق',
        expertAdvisory: 'المستشار الخبير',
        technicalAnalysis: 'أدوات التحليل الفني',
        liveNews: 'الأخبار المباشرة',
        maxPositions: 'العدد الأقصى للمراكز',
        freeData: 'بيانات السوق المجانية',
        swap: 'المبادلة',
        phoneSupport: 'دعم هاتفي 24/6',
        educationalVideos: 'فيديوهات وأدلة تعليمية',
        chartingPackages: 'حزم الرسوم البيانية المتقدمة',
        seminars: 'ندوات شخصية وعبر الإنترنت',
        newsArticles: 'أخبار ومقالات من ريفر برايم',
        yes: 'نعم',
        allowed: 'مسموح',
        allMarkets: 'جميع الأسواق',
        noLimitations: 'بلا حدود',
        free: 'مجاناً*'
      }
    },

    // Markets Pages
    markets: {
      forex: {
        hero: {
          title: 'تداول العملات الأجنبية (الفوركس)',
          subtitle: 'تداول أكثر من 50 زوج من العملات مع فروق أسعار منافسة ورافعة مالية حتى 1:400',
          description: 'انضم إلى ملايين المتداولين حول العالم في سوق الصرف الأجنبي، أكبر الأسواق المالية وأكثرها سيولة في العالم بحجم تداول يومي يزيد عن 6 تريليون دولار.'
        },
        instruments: {
          title: 'أدوات تداول الفوركس',
          subtitle: 'تداول أزواج العملات الرئيسية والثانوية والنادرة مع فروق أسعار تنافسية',
          headers: {
            symbol: 'الرمز',
            description: 'الوصف',
            minSpread: 'أدنى فرق سعر',
            avgSpread: 'فرق السعر المعتاد',
            commission: 'العمولة'
          },
          note: '*ملاحظة: تقلبات أسعار الهامش تتأثر بالرافعة المالية'
        },
        whyTrade: {
          title: 'لماذا تتداول الفوركس مع ريفر برايم؟',
          benefits: [
            {
              icon: '💰',
              title: 'فروق أسعار منافسة',
              description: 'استفد من فروق أسعار ضيقة تبدأ من 0.8 نقطة على أزواج العملات الرئيسية'
            },
            {
              icon: '⚡',
              title: 'تنفيذ سريع',
              description: 'تنفيذ الصفقات بسرعة البرق مع زمن استجابة أقل من 10 مللي ثانية'
            },
            {
              icon: '🛡️',
              title: 'رافعة مالية مرنة',
              description: 'اختر الرافعة المالية المناسبة لك حتى 1:400 مع إدارة مخاطر متقدمة'
            },
            {
              icon: '📱',
              title: 'منصات متقدمة',
              description: 'تداول على منصة MT5 المتطورة مع أدوات تحليل فني شاملة'
            },
            {
              icon: '🌍',
              title: 'تداول على مدار الساعة',
              description: 'تداول الفوركس 24 ساعة، 5 أيام في الأسبوع مع دعم عملاء متواصل'
            },
            {
              icon: '📊',
              title: 'تحليل متقدم',
              description: 'احصل على تحليلات السوق اليومية وإشارات التداول من خبرائنا'
            }
          ]
        },
        accountComparison: {
          title: 'قارن أنواع الحسابات',
          subtitle: 'اختر نوع الحساب الذي يناسب أسلوب تداولك',
          accounts: {
            pro: 'حساب المحترف',
            prime: 'الحساب المميز', 
            premium: 'حساب الخبير'
          },
          features: {
            minDeposit: 'الحد الأدنى للإيداع',
            spread: 'فرق السعر',
            commission: 'العمولة',
            leverage: 'الرافعة المالية',
            instruments: 'الأدوات المالية',
            support: 'الدعم',
            startingDeposit: 'الإيداع الابتدائي',
            spreadsFrom: 'فروق الأسعار من',
            platform: 'المنصة',
            islamicAccounts: 'الحسابات الإسلامية',
            orderExecution: 'تنفيذ الأوامر',
            findOutMore: 'اكتشف المزيد',
            available: 'متاح',
            market: 'السوق'
          }
        }
      },
      indices: {
        hero: {
          title: 'تداول المؤشرات العالمية',
          subtitle: 'تداول أشهر المؤشرات العالمية مثل S&P 500 وDAX وFTSE 100 بفروق أسعار منافسة',
          description: 'استثمر في أداء الاقتصادات الكبرى من خلال تداول المؤشرات العالمية. احصل على تعرض متنوع للأسواق مع صفقة واحدة.'
        },
        instruments: {
          title: 'أدوات تداول المؤشرات',
          subtitle: 'تداول أهم المؤشرات العالمية من الأسواق الأمريكية والأوروبية والآسيوية',
          headers: {
            symbol: 'الرمز',
            description: 'الوصف',
            minSpread: 'أدنى فرق سعر',
            avgSpread: 'فرق السعر المعتاد',
            commission: 'العمولة'
          },
          note: '*ملاحظة: تقلبات أسعار الهامش تتأثر بالرافعة المالية'
        },
        whyTrade: {
          title: 'لماذا تتداول المؤشرات مع ريفر برايم؟',
          benefits: [
            {
              icon: '🌍',
              title: 'تنويع عالمي',
              description: 'تداول المؤشرات من أهم الأسواق العالمية في أمريكا وأوروبا وآسيا'
            },
            {
              icon: '📈',
              title: 'فروق أسعار ضيقة',
              description: 'استفد من فروق أسعار تنافسية على جميع المؤشرات الرئيسية'
            },
            {
              icon: '⏰',
              title: 'ساعات تداول مرنة',
              description: 'تداول المؤشرات في أوقات مختلفة حسب أسواقها المحلية'
            },
            {
              icon: '💼',
              title: 'تعرض متنوع',
              description: 'احصل على تعرض لمئات الشركات من خلال صفقة واحدة'
            },
            {
              icon: '📊',
              title: 'تحليل شامل',
              description: 'تحليلات فنية وأساسية متقدمة لجميع المؤشرات'
            },
            {
              icon: '🛡️',
              title: 'إدارة مخاطر',
              description: 'أدوات متقدمة لإدارة المخاطر مع أوامر الإيقاف المضمونة'
            }
          ]
        },
        accountComparison: {
          title: 'قارن أنواع الحسابات',
          subtitle: 'اختر نوع الحساب الذي يناسب أسلوب تداولك',
          accounts: {
            pro: 'حساب المحترف',
            prime: 'الحساب المميز', 
            premium: 'حساب الخبير'
          },
          features: {
            minDeposit: 'الحد الأدنى للإيداع',
            spread: 'فرق السعر',
            commission: 'العمولة',
            leverage: 'الرافعة المالية',
            instruments: 'الأدوات المالية',
            support: 'الدعم',
            startingDeposit: 'الإيداع الابتدائي',
            spreadsFrom: 'فروق الأسعار من',
            platform: 'المنصة',
            islamicAccounts: 'الحسابات الإسلامية',
            orderExecution: 'تنفيذ الأوامر',
            findOutMore: 'اكتشف المزيد',
            available: 'متاح',
            market: 'السوق'
          }
        }
      },
      commodities: {
        hero: {
          title: 'تداول السلع والمعادن الثمينة',
          subtitle: 'تداول الذهب والفضة والنفط والغاز الطبيعي مع فروق أسعار منافسة',
          description: 'استثمر في السلع الأساسية التي تحرك الاقتصاد العالمي. من المعادن الثمينة إلى مصادر الطاقة، تداول السلع كتحوط ضد التضخم.'
        },
        instruments: {
          title: 'أدوات تداول السلع',
          subtitle: 'تداول المعادن الثمينة ومصادر الطاقة والسلع الزراعية',
          headers: {
            symbol: 'الرمز',
            description: 'الوصف',
            minSpread: 'أدنى فرق سعر',
            avgSpread: 'فرق السعر المعتاد',
            commission: 'العمولة'
          },
          note: '*ملاحظة: تقلبات أسعار الهامش تتأثر بالرافعة المالية'
        },
        whyTrade: {
          title: 'لماذا تتداول السلع مع ريفر برايم؟',
          benefits: [
            {
              icon: '🥇',
              title: 'معادن ثمينة',
              description: 'تداول الذهب والفضة كملاذ آمن ضد التقلبات الاقتصادية'
            },
            {
              icon: '⛽',
              title: 'مصادر الطاقة',
              description: 'استثمر في النفط والغاز الطبيعي، محركات الاقتصاد العالمي'
            },
            {
              icon: '🌾',
              title: 'سلع زراعية',
              description: 'تنويع محفظتك مع السلع الزراعية الأساسية'
            },
            {
              icon: '📊',
              title: 'تحليل السوق',
              description: 'تحليلات متخصصة لأسواق السلع من خبراء القطاع'
            },
            {
              icon: '🛡️',
              title: 'حماية من التضخم',
              description: 'السلع كأداة تحوط فعالة ضد التضخم وتقلبات العملات'
            },
            {
              icon: '⚡',
              title: 'تنفيذ سريع',
              description: 'تنفيذ فوري للصفقات مع أفضل الأسعار المتاحة'
            }
          ]
        },
        news: {
          title: 'أخبار السلع',
          bidPrice: 'سعر العرض',
          askPrice: 'سعر الطلب'
        },
        help: {
          title: 'مساعدة سريعة وسهلة',
          experienced: {
            title: 'هل أنت متداول ذو خبرة؟',
            partner: {
              title: 'كن شريكاً',
              description: 'وسّع إمكانياتك من خلال برامج الشراكة الخاصة بنا.'
            },
            markets: {
              title: 'استكشف جميع الأسواق',
              description: 'احصل على عالم من الفرص ونوّع محفظتك مع أسواق جديدة.'
            },
            events: {
              title: 'اعرف جميع الأحداث الاقتصادية',
              description: 'انغمس في التقويم الاقتصادي الإبداعي الذي يوفر معلومات محدثة حول الأحداث الاقتصادية.'
            }
          },
          newTrader: {
            title: 'هل أنت متداول جديد؟',
            platform: {
              title: 'منصة التداول الإلكترونية',
              description: 'استخدم منصة التداول بنقرة واحدة. اكسب المال من الأسواق المالية الرائدة أثناء نومك.'
            },
            charts: {
              title: 'فهم الرسوم البيانية للتداول',
              description: 'تحليل الرسوم البيانية يمكن أن يساعدك على فهم الحالة الحالية لأي سوق. رؤى موجزة لاتخاذ قرارات مدروسة.'
            },
            demo: {
              title: 'إنشاء حساب تجريبي',
              description: 'أنشئ استراتيجية تداول مبنية على الحقائق. تعلم كيفية إنشاء استراتيجية تداول مربحة.'
            }
          }
        },
        accountComparison: {
          title: 'قارن أنواع الحسابات',
          subtitle: 'اختر نوع الحساب الذي يناسب أسلوب تداولك',
          accounts: {
            pro: 'حساب المحترف',
            prime: 'الحساب المميز', 
            premium: 'حساب الخبير'
          },
          features: {
            minDeposit: 'الحد الأدنى للإيداع',
            spread: 'فرق السعر',
            commission: 'العمولة',
            leverage: 'الرافعة المالية',
            instruments: 'الأدوات المالية',
            support: 'الدعم',
            startingDeposit: 'الإيداع الابتدائي',
            spreadsFrom: 'فروق الأسعار من',
            platform: 'المنصة',
            islamicAccounts: 'الحسابات الإسلامية',
            orderExecution: 'تنفيذ الأوامر',
            findOutMore: 'اكتشف المزيد',
            available: 'متاح',
            market: 'السوق'
          },
          mostPopular: 'الأكثر شعبية',
          demo: {
            title: 'لست مستعداً بعد؟',
            description: 'جرب الحساب التجريبي أولاً لترى ما ينتظرك!',
            button: 'جرب الحساب التجريبي'
          }
        }
      },
      shares: {
        hero: {
          title: 'تداول عقود فروقات الأسهم',
          subtitle: 'تداول أكثر من 300 سهماً وصندوق استثماري بأسعار تنافسية للوصول إلى المزيد من الفرص الاستثمارية المتاحة يومياً. بنقرة واحدة، احصل على إمكانية الوصول لأشهر الشركات العالمية مثل Apple وAmazon وMicrosoft والمزيد.',
          question: 'مستعد؟',
          platform: 'منصة تداول حائزة على جوائز',
          clients: '10,000+ عميل راضٍ حول العالم',
          tools: 'أدوات وأجهزة متفوقة'
        },
        instruments: {
          title: 'أدوات تداول الأسهم',
          button: 'الذهاب إلى جميع الأدوات',
          subtitle: 'تداول أسهم الشركات الكبرى من البورصات الأمريكية والأوروبية',
          headers: {
            symbol: 'الرمز',
            description: 'الوصف',
            contractSize: 'حجم العقد',
            marginRate: 'معدل الهامش'
          },
          note: '*ملاحظة: تقلبات أسعار الهامش تتأثر بالرافعة المالية'
        },
        whyTrade: {
          title: 'لماذا تتداول الأسهم مع ريفر برايم؟',
          benefits: [
            {
              icon: '📱',
              title: 'أسهم التكنولوجيا',
              description: 'تداول أسهم عمالقة التكنولوجيا مثل Apple وGoogle وMicrosoft'
            },
            {
              icon: '🏦',
              title: 'القطاع المصرفي',
              description: 'استثمر في أكبر البنوك العالمية والمؤسسات المالية'
            },
            {
              icon: '⚡',
              title: 'بيع على المكشوف',
              description: 'تداول الارتفاع والانخفاض - استفد من حركات السوق في كلا الاتجاهين'
            },
            {
              icon: '💰',
              title: 'بدون عمولات',
              description: 'تداول عقود فروقات الأسهم بدون عمولات إضافية'
            },
            {
              icon: '🎯',
              title: 'رافعة مالية',
              description: 'استخدم الرافعة المالية حتى 1:20 لتعظيم قوتك الشرائية'
            },
            {
              icon: '📊',
              title: 'تحليل الأسهم',
              description: 'تحليلات شاملة للشركات مع التقارير المالية والأخبار'
            }
          ]
        },
        accountComparison: {
          title: 'قارن أنواع الحسابات',
          subtitle: 'اختر نوع الحساب الذي يناسب أسلوب تداولك',
          accounts: {
            pro: 'حساب المحترف',
            prime: 'الحساب المميز', 
            premium: 'حساب الخبير'
          },
          features: {
            minDeposit: 'الحد الأدنى للإيداع',
            spread: 'فرق السعر',
            commission: 'العمولة',
            leverage: 'الرافعة المالية',
            instruments: 'الأدوات المالية',
            support: 'الدعم',
            startingDeposit: 'الإيداع الابتدائي',
            spreadsFrom: 'فروق الأسعار من',
            platform: 'المنصة',
            islamicAccounts: 'الحسابات الإسلامية',
            orderExecution: 'تنفيذ الأوامر',
            stopOutLevel: 'مستوى الإيقاف',
            minOrderSize: 'الحد الأدنى لحجم الطلب',
            accountCurrency: 'عملة الحساب',
            hedging: 'التحوط',
            ea: 'المستشار الخبير',
            tradingInstruments: 'أدوات التداول',
            findOutMore: 'اكتشف المزيد',
            available: 'متاح',
            market: 'السوق',
            yes: 'نعم',
            allowed: 'مسموح',
            fxMetalsCommodities: 'العملات، المعادن، السلع، المؤشرات، عقود فروقات الأسهم'
          },
          mostPopular: 'الأكثر شعبية',
          demo: {
            title: 'لست مستعداً بعد؟',
            description: 'جرب الحساب التجريبي أولاً لترى ما ينتظرك!',
            button: 'إنشاء حساب تجريبي'
          }
        }
      }
    },

    // Footer Disclaimer
    disclaimer: {
      title: 'تحذير من المخاطر',
      paragraph1: 'تحذير من المخاطر: ينطوي تداول العملات الأجنبية والمعادن الثمينة والعقود مقابل الفروقات على الهامش على درجة عالية من المخاطر. فمن الممكن أن تؤدي إلى خسارة كامل رأس مالك ، وقد لا تكون أدوات التداول هذه مناسبة للجميع. يجب عليك التأكد من فهمك للمخاطر التي تنطوي عليها. إبحث عن مشورة خبراء مستقلين إذا لزم الأمر ولا تتداول إلا بالأموال التي يمكنك تحمل خسارتها. يرجى التفكير ملياً فيما إذا كان هذا النوع من التداول يناسبك ، مع الأخذ في الإعتبار جميع الظروف ذات الصلة وكذلك مواردك الشخصية. لا نوصي العملاء بالتداول بكامل رصيد حسابهم تجنباً لمطالبات الهامش ، ويمكن للعملاء تقليل مستوى تعرضهم للمخاطر عن طريق طلب تغيير حدود الرافعة المالية.',
      paragraph2: 'المعلومات الواردة في هذا الموقع هي معلومات معرفية عامة، ولا تأخذ بعين الاعتبار أهدافك الشخصية، أو ظروفك المالية، أو احتياجاتك. يرجى قراءة المستندات القانونية والتأكد من فهمك الكامل للمخاطر قبل اتخاذ أي قراربالتتداول. لا يمكن لشركة River Prime أن تضمن أو تتحمل أي مسؤولية قانونية عن مدى توافق المعلومات أو دقّتها ، أو موضوعيتها ، أو اكتمالها.',
      regionalRestrictions: 'القيود الإقليمية:',
      regionalText: 'نحن لا نقدّم خدماتنا للمقيمين في البلدان التي تخضع لسلطات قضائية معينة، مثل الولايات المتحدة. وكذلك، في البلدان الخاضعة لقوائم عقوبات مجموعة العمل المالي (FATF)، وقوائم عقوبات الاتحاد الأوروبي / الأمم المتحدة.',
      paragraph3: 'المعلومات الواردة في هذا الموقع، والمنتجات، والخدمات المقدمة مجهّزة خصيصاً لعملاء River Prime ، ولا يُسمح بإعادة نشرها واستخدامها من قبل أي شخص في أي بلد أو ولاية قضائية يقدّم فيها هذه الخدمات، أو استخدامها بطريقة مخالفة للقانون أو اللوائح المحلية. يجب أن يتمتع العملاء بالأهلية القانونية لإبرام العقود واستخدام خدمات  River Prime.'
    },

    // Common
    common: {
      loading: 'جارٍ التحميل...',
      error: 'خطأ',
      success: 'نجح',
      close: 'إغلاق',
      open: 'فتح',
      menu: 'القائمة'
    }
  }
};

const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      // Fallback to English if translation not found
      value = translations.en;
      for (const fallbackKey of keys) {
        if (value && typeof value === 'object' && fallbackKey in value) {
          value = value[fallbackKey];
        } else {
          return key; // Return the key if no translation found
        }
      }
      break;
    }
  }
  
  return value || key;
};

export { translations, getTranslation };